export default {
  en: {
    downloadMobileVersion: 'Download mobile version',
    news: 'News',
    userManual: 'User manual',
    textLocal: 'Language',
    textThemes: 'Dark theme',
    exit: 'Exit',
    // ***
    severstalInfocom: 'Severstal-Infocom',
    login: 'Login',
    welcome: 'Welcome',

    name: 'Name',
    password: 'Password',
    loading: 'Loading...',
    textErrorName: 'Please enter username',
    textErrorPassword: 'Please enter password',
    textTitleAuth: 'Remote stockyard management',
    textSupportPhone: 'Support phone number',
    textFooterLeftStart: '© 2020-',
    textFooterLeftFinish: ' “Severstal”. All rights reserved',
    textFooterRight: 'Write to Support',
    textSelectStock: 'Select stockyard',
    textContinue: 'Continue',
    textBindChangeRolls: 'Bind/Change PF',
    textBindChangeProducts: 'Bind/Change RP', // сократила Ready Product как RP, надо уточнить как правильно
    textTabRecyclingOrders: 'Recycling orders',
    textTabSO: 'Orders',
    textTabTasks: 'Tasks',
    textTabListMetalAvailable: 'Metal availability',
    textTabListMetalReport: 'Metal receiving',
    textTabListWasteBalancing: 'Waste balancing',
    textTabListReports: 'Reports',
    textTabListProduction: 'Production',
    textTabListStockMetrics: "Stock's Metrics",
    textTabListScanning: 'Scanning',
    textTabListResponsiblePersons: 'Responsible persons',
    textTabListStock: 'Stockyard',
    textTabListEditAct: 'Act editing',
    textTabEditTtn: 'TN Edit',
    textTabUserManual: 'User surveys',
    textSurveyTab: 'Опросы пользователей',
    textReport: [
      'Information in stockyard material movement',
      'Keeper report',
      'Register of acts',
      'Loading plan',
      'Inventory',
      'Movement metall',
      'Inventory "INV-3"',
      'Overdue storage',
      'Ready product report',
      'Processing production plan report',
      'Returns Report',
      'TN report',
      'Quarantine report',
      'Recycler report'
    ],
    textReportCalculationPay: {
      name: 'Calculation of remuneration',
      data: ['All metal', 'Only metal returned from storage']
    },
    textReportTypeAct: {
      name: 'Type of acts',
      data: ["All act'", 'Only not processed acts', 'Only signed acts']
    },
    error: 'Error',
    textReportSuccess: 'The report was generated successfully',
    textReportName: 'Report name',
    textReportDross: 'Dross, tons',
    textSelectPeriod: 'Select the correct period',
    textSelectDate: 'Select the date',
    textReportNumber: 'Report number',
    textSelectDateTime: 'Select the date',
    textTypeProduct: 'Select the product type',
    textActSendSuccess: 'The Act was successfully sent to the bailor',
    textPeriodAcceptance: 'The period of acceptance',
    textShipmentPeriod: 'Shipment period',
    textRedemptionPeriod: 'Redemption period',
    textRecyclingPeriod: 'Recycling period',
    textPeriod: 'Period',
    textStock: 'Stock',
    textSelectItem: 'Select item',
    textСost: 'Price (₽ rub.)',
    textArrivalDate: 'Cargo arrival date',
    textButton: {
      add: 'Add',
      addHolderReport: 'New',
      addReady: 'Add ready',
      addSurvey: 'Create survey',
      addToReportOverStorageDates: 'Add to report SPO',
      all: 'All',
      back: 'Back',
      bind: 'Bind',
      bind_unbind: 'Bind/Unbind',
      buyOut: 'Buy out',
      cancel: 'Cancel',
      cancelPlanning: 'Cancel planning',
      cancelProcessing: 'Cancel processing',
      cancelSend: 'Cancel send to SAP',
      cancelShipment: 'Cancel shipment',
      checkXml: 'Check XML',
      close: 'Close',
      closeOrder: 'Close order',
      confirm: 'Confirm',
      continue: 'Continue',
      create: 'Create',
      createChapter: 'Create chapter',
      createManual: 'Create manual',
      createTask: 'Task',
      delete: 'Delete',
      deleteScanedPiece: 'Delete from list',
      downloadQc: 'Download QC',
      edit: 'Edit',
      export: 'Export',
      forward: 'Forward',
      inputAllWaste: 'Input all waste',
      inputData: 'Input data',
      inputReady: 'Input ready',
      inputTrim: 'Input trim',
      inputUndercut: 'Input undercut',
      inputWaste: 'Input waste',
      inStock: 'In stock',
      inTransit: 'In transit',
      loadingPlanning: 'Loading planning',
      no: 'No',
      passLater: 'Pass later',
      passNow: 'Pass now',
      placeStock: 'Place to the stockyard',
      preview: 'Preview',
      print: 'Print',
      printQcFromQmet: 'Print transhipment ',
      printQcFromStorage: 'Print original',
      processing: 'Processing',
      rebinding: 'Rebind',
      refuseAcceptance: 'Refuse acceptance',
      reject: 'Reject',
      remove: 'Remove',
      removeFromAct: 'Remove from act',
      removeFromActM15: 'Remove from M15',
      reset: 'Reset',
      returned: 'Returned',
      rid: 'Rid',
      save: 'Save',
      send: 'Send',
      shipped: 'Shipped',
      storno: 'Storno',
      submerge: 'Submerge',
      subscribe: 'Subscribe',
      textOpen: 'Open',
      textReturn: 'Return',
      toMount: 'To mount',
      toShip: 'To ship',
      toUnmount: 'To unmount',
      ttnCreate: 'TN create',
      ttnUpdate: 'TN update',
      writeOff: 'Write off',
      yes: 'Yes',
      yesCancel: 'yes, cancel',
      doNotShowAgain: 'Do not show again',
      complete: 'Complete',
      resume: 'Resume',
      copyAll: 'Copy all',
      copied: 'Copied',
      notification: 'Notification'
    },
    textDataGrid: {
      alreadySelected: 'Already selected',
      availableForBinding: 'Available for binding',
      capacityPipe: 'volume of pieces',
      exportExcel: 'Export to Exсel',
      gross: 'gross',
      nett: 'nett',
      pcs: 'pcs',
      pieceQU: 'Piece quantity',
      quantity: 'quantity',
      quantityRemain: 'remains',
      selectedSum: 'summary',
      selectOrders: 'Pieces orders',
      selectQU: 'Pieces selected',
      textSearch: 'Search',
      textTotal: 'Total',
      tonne: 'tonne'
    },
    textError: {
      addFile: 'Add file',
      cannotProcess: 'The server cannot process the request, please try again later.',
      contactSupport: 'contact customer support',
      detail: 'Detail',
      differentShiptoAddressSo:
        'One act cannot include accounting units with different addresses of the consignee',
      differentWarehousesSelected: 'Different warehouses selected',
      endSession: 'Your session of work in MES US has ended.\nTo continue working, please log in again.',
      enterActualShippingDate: 'Insert the actual shipment date',
      enterContainerNumber: 'Insert container №',
      enterDate: 'Insert date',
      enterDateLoadingContainer: 'Insert container loading date',
      enterDateRange: 'Enter date range',
      enterDescription: 'Insert description',
      enterDocumentNum: 'Insert document number',
      enterMH3Number: 'Insert MH-3 №',
      enterNumberRailShippDoc:
        'Insert railroad bill of lading № or shipping document',
      enterPieceId: 'Insert Piece number',
      enterQcId: 'Insert quality certificate',
      enterQRCode: 'Scan QRcode or enter it',
      enterQuantityOff: 'Insert actual quantity',
      enterQuantity: 'Insert theoretical quantity',
      enterReasonForCancelingRansom: 'Insert reason for canceling the ransom',
      enterRejectionReason: 'Insert rejection reason',
      enterSealNumber: 'Insert seal №',
      enterShippingCancellationReason: 'Insert shipping cancellation reason',
      enterShippingDate: 'Insert shipping document dat',
      enterTtnDate: 'Insert TTN date',
      enterVeichle: 'Insert veichle №',
      errorLoadQC: 'Error loading selected QC',
      fieldNotFilled: 'Field not filled in',
      gatewayTimeout: 'The server cannot contact the requested resource at the moment, or the response has timed out.',
      incorrectDateRange: 'Incorrect date range',
      mustSelectPrintQCSource: 'You must select a print source for QC',
      needTtn: 'The operation has not been saved, you need to attach a TTN',
      noMatchingOrder: 'There is no matching order in stock',
      noValueSelected: 'No value selected',
      parametersSelectProductDoNotMatch: 'The parameters of the selected product do not match',
      reportCreateError: 'Report create error',
      requestTimeout: 'The timeout has expired. Please check your connection is stable and try again.',
      selectPlants: 'Select plant',
      selectZdvlLineNumId: 'Select ZDVL line num id',
      serviceUnavailable: 'MES US is currently unavailable, please contact support.',
      setRealPriorityShippingDays: 'The number of days for the 2nd priority must always be less than for the 1st',
      textErrorDeleteMessage: 'Error deleting news item, please contact support',
      textErrorFifo: 'It is necessary to select the semi in accordance with the FIFO model',
      textErrorNotEnoughSemi: 'Not enough semi-finished product to complete the task',
      textIncorrect:
        'The data is entered incorrectly or your account does not exist in the corporate network. \nPlease try again or contact customer support.',
      textSymbolsLimitMh3: 'The "Inventory items-3 №/Storage Completion Act" field cannot contain more than 50 characters',
      unauthorized: 'To receive the requested response, you must enter your username and password to enter the site.',
      unknownError: 'Unknown error - contact support',
      useMCnotFTO:
        'If the condition "Using master rolls" is selected, "finished products/semi-finished product warehouse" and vice versa cannot be enabled',
      useM15BWithoutM15: 'M15B must be used with M15',
      useWithBuyoutWithTtn: 'This setting should work with the enabled setting - Shipment/Buyout ready product by TTN from consigning/recycling stocks',
      useWithoutAutoShipmentCondition: 'This setting should work with the disabled setting - Automatic determination of the shipment condition',
      useWithoutDisableTtnNumberInput: 'This setting should work with the disabled setting - Disabling the input of the TN number for auto, except for LPC-3',
      useWithoutShippingVehicleOnly: 'This setting should work with the disabled setting - Using only the vehicle number and the date of actual shipment',
      vehicleNumFormat1: 'Entered number',
      vehicleNumFormat2: 'does not match the format',
      vehicleNumFormat3: 'When shipping by car, you must enter the vehicle number in the format "Tractor number/trailer number". For example, A123AA123/AA123456.',
      warning: 'Warning',
      wasteWithSemi: 'Both "Waste output quantity" and "Quantity semi off" fields must be filled in'
    },
    dataSuccess: 'Data was updated successfully',
    textSuccess: 'Successfully',
    textAlreadyFound: 'Already found',
    textNoData: 'There is no data',
    pieceStatusChanged: 'Piece status changed',
    actsSigned: 'Acts signed',
    taskStatusChanged: 'Task status changed',
    textModal: {
      addPiece: 'Add items',
      addReportOverdue: 'Add to report overdue storage',
      attachedFile: 'Attached file',
      buyMetal: 'Metal buying out',
      cancellationOfLoading: 'Cancellation of loading',
      cancellationOfRedemption: 'Cancellation of redemption',
      cancellationOfProcessing: 'Cancellation of processing',
      createTN: 'Create TN',
      deleteAct: 'Deleting an act',
      deletePiece: 'Delete piece',
      deleteReport: 'Deleting a report',
      description: 'Description',
      nameChapter: 'Chapter name',
      nameManual: 'Manual name',
      refusalToAccept: 'Refusal to accept',
      placementStock: 'Placement in a stockyard',
      metalReceiving: 'Metal receiving',
      metalProcessing: 'Metal processing',
      selectQU: 'Selected pieces',
      surveyEndDate: 'Survey end date',
      surveyStartDate: 'Survey start date',
      surveyTitle: 'Survey title',
      loadingMetal: 'Metal loading',
      rebindingSZ: 'Rebinding system sales order',
      returnMetal: 'Metal return',
      returnType: 'Return type',
      textBindRolls: 'Bind selected rolls?',
      textRidRolls: 'Unbind PF at production end?',
      textActErrorLeft: 'Act',
      textActErrorRight:
        'have already been generated and sent for these pieces. To include accounting units in a new act, you must remove them from the existing act.',

      textActErrorMx1Left:
        'The act of acceptance of the transfer-1 (MX-1/M-4) for',
      textActErrorMx1Right: 'was not completed or was not signed',
      textActErrorMx3Left: 'This quality sertificate №',
      textActErrorMH3NotSent: 'Remind you that the following MX-3 acts have not been sent to Severstal',
      textActErrorMx3Center: 'already included in act №',
      textActErrorMx3Right: 'In order to change to change the number of the act, it is necessary to remove this SK from the act №',
      textZeroWeightRemainErrorLeft: 'Redemption is not possible for the QC:',
      textZeroWeightRemainErrorRight: 'because the residual weight of the semi-finished product is 0 tons',
      textCreateSk: 'Create quality sertificate',
      textCreateAct: 'Create act',
      textCreateInvoice: 'Create invoice',
      textBailorSendAct1Left: 'Sign and send Act',
      textBailorSendReport: 'Sign and send Holder report',
      textBailorSendAct1Right: 'to the bailor?',
      textBailorSendAct2Left: 'Open or resend Act',
      textBailorSendReportSent: 'Open or resend Report',
      textHolderReport: 'Holder report',
      textBailorSendAct2Right: 'to the bailor?',
      textBailorSendInvoice1Left: 'Sign and send invoice',
      textBailorNotSigned: 'You have not signed the act',
      textBailorSendInvoice1Right: 'to the bailor?',
      textBailorSendInvoice2Left: 'Open or resend invoice',
      textBailorSendInvoice2Right: 'to the bailor?',
      textQRCode: 'Product scanning',
      textQRCodeCamera: 'Point the camera to the QR, barcode, and DataMatrix',
      textIncomingF1Left: 'Quality Certificate №',
      textIncomingF1Right:
        ' was PHYSICALLY returned to the workshop. Contact the shipping shop',
      textIncomingF2Left:
        'A LOGICAL return to the stock was issued for the quality certificate №',
      textIncomingF2Right: ' contact the shipping shop',
      textIncomingHoldLeft: 'Quality Certificate No.',
      textIncomingHoldRight: 'has been added to the quarantine',
      textIncomingNoSoDescrLeft: 'Quality Certificate No.',
      textIncomingNoSoDescrRight:
        'has no data on the order. Shipment is impossible!',
      textMPLeft: 'This piace is included in the Master Coil №',
      textMPRight: 'Use the Master-coil',
      fromAct: 'from act(s)',
      respectively: 'respectively',
      textSubscribe: 'To generate a specification(s) for the selected order',
      textReject: 'Do rejection signing of selected order item(s)',
      textSignAndSend: 'Sign and send',
      textSignAndSendOrder: 'Sign and send order №',
      textRejectOrderAcceptance: 'Reject order acceptance №',
      textRejectOrderAcceptanceTitle: 'Reject order acceptance',
      textShipmentPlanning: 'Shipment planning',
      textShipmentPlanningCancel: 'Cancel planed shipping',
      textOpen: 'Open',
      textOpenOrder: 'Open order',

      textShipmentCheckFIFO:
        'Verification of compliance with the FIFO principle',

      selectQUCheckFIFO:
        'The selected items did not satisfy the FIFO, continue with the following?',
      continue: 'Continue',
      exportPDF: 'Export to PDF',
      exportExcel: 'Export to EXCEL',
      noteText: 'Special notes',
      noteTextSave: 'Special notes was saved',
      textDifferentHoldFlag:
        'For next operation, it is necessary to select either in quarantine only, or not in quarantine',
      textDifferentQCShipment:
        'You have selected items from the production of the LPC-3 and other workshop, select the same type of items or disable the option "Использование только № ТС и даты фактической отгрузки"',
      textIncomingProhibitionLeft: 'According to order No.',
      textIncomingProhibitionRight: 'loading is prohibited',
      textZdvlCloseP1: 'Are you sure you want to close order(s) № ',
      textZdvlCloseP2: 'line(s) № ',
      textZdvlClosedWarningP1: 'Selected line № ',
      textZdvlClosedWarningP2: 'order № ',
      textZdvlClosedWarningP3: 'CLOSED',
      textAddSemiTask: 'Add ZDVL rolls',
      textAddZdvlLine: 'Add ZDVL',
      textDeleteTask: 'Delete task',
      textDeleteTaskConfirm: 'Are you sure want to delete this task',
      textStornoHeading: 'Storno reason',
      textStornoInput: 'Enter reason for storno',
      textConfirmQC: 'Confirm sending QC',
      textFrom: 'from',
      textModalPrintTasks: 'Tasks',
      textModalDate: 'Enter date',
      textModalDateFrom: 'Date from',
      textModalDateTo: 'Date to',
      textSelectSentOnly: 'You need to select items only in the Sent status',
      textSelect10QCOrLess: 'Select 10 QC or less',
      youSure: 'Are you sure',
      textDeleteAct: 'Are you sure you want to delete the document',
      textDeleteHolderReport: 'Are you sure you want to delete the report',
      listPiece: 'List of items',
      textSOBindP1: 'Bind QC № ',
      textSOBindP2: 'to order № ',
      textSOBindP3: 'Unbind QC № ',
      textSOBindP4: 'from order № ',
      textSOBindP5: 'line № ',
      textSOMaxToleranceWarn: 'the maximum tolerance has been exceeded.',
      textSOMaxCapacity: 'As much as possible to bind:',
      textSOBinding: 'binds: ',
      textSOWrongStatusLeft: 'Binding to SO № ',
      textSOWrongStatusCenter: ' line № ',
      textSOWrongStatusRight: ' is not possible. The SO status must be "Accepted" to bind a RP(QU)',
      textDifferentShipmentMode: 'selected items from different shipment mode',
      textCheckShipping: 'Checking the data before shipment',
      textActStatus: 'Check the statuses of the acts, all acts must have the status "Formed".',
      textUpdateZDVL: 'Updating the recycling order',
      textAddMessage: 'Add message',
      textEditMessage: 'Edit message',
      textMessageShippingType: 'Shipping type',
      textMessageType: 'Message type',
      textMessageDate: 'Message date',
      textActiveToDate: 'Up to date',
      textMessageTitle: 'Message title',
      textMessageText: 'Message',
      signActsByClient: 'To sign the acts',
      textVehicleTn: 'Select vehicle',
      textVehicleTnAdd: 'Add vehicle',
      textTrailerTn: 'Select trailer',
      textTrailerTnAdd: 'Add trailer',
      textDriverTn: 'Select driver',
      textDriverTnAdd: 'Add driver',
      textPackingTypeTn: 'Choose packing type',
      textPackingTypeTnAdd: 'Add packing type',
      textTnList: 'Select TN',
      confirmTn: 'Confirm TN',
      confirm: 'Confirm',
      textConfirmTn: 'Are you sure you want to confirm TN',
      editTn: 'Edit TN',
      textCreateTn: 'Create TN',
      textOpenConfirmedTn: 'Open TN',
      deleteTn: 'Delete TN',
      textDeleteTn: 'Are you sure you want to delete TN',
      textResponsiblePersonTn: 'Select responsible person',
      textResponsiblePersonTnAdd: 'Add responsible person',
      textNoCapacityAvailable: 'There is no capacity available to position',
      textNoCapacityAvailableOrder: 'to order',
      textVideoManuals: 'Video manual',
      textTransportCompany: 'Select transport company',
      serviceQualityAssessment: 'MESUS service quality assessment',
      textTypeReturnYInfo:
        'Physical return refers to the process of sending goods back to the point of shipment for rework, corrections, etc.',
      textTypeReturnNInfo:
        'Logical return - a QC status change that allows the workshop to make modifications in the QC system without physically returning the metal to the shipping location.'
    },
    textZone: 'Zone',
    textBox: 'Box',
    textTypeReturn: {
      y: 'Physical',
      n: 'Logical'
    },
    textData: {
      acceptanceTransfer1Number: 'Acceptance-transfer-1/M-4 №',
      acceptanceTransfer15Number: 'M-15/M-4 №',
      acceptanceTransfer1and15Number: 'Acceptance-transfer-1 № and M-15 №',
      acceptanceTransfer4Number: 'M-4',
      actualShippingDate: 'Actual shipping date',
      clientList: 'Client list',
      containerInspectedFlag: 'Container inspected, in good condition',
      containerNumber: 'Container №',
      containerType: 'Container type',
      contractNumber: 'Contract №',
      date: 'Date',
      dateLoadingContainer: 'Container loading date',
      documentForProduction: 'Move to processing contract',
      documentNumber: 'Document №',
      internalPieceNumber: 'Internal Piece number',
      inventoryItems3Number: 'Inventory items-3 №/Storage Completion Act',
      mh3: 'Act of return of inventory items-3',
      numberRailShippDoc: 'Railroad bill of lading № or shipping document',
      nextPlants: 'Next plant',
      orderListNumber: 'System sales order №',
      qc: 'QC number',
      reasonForCancelingRansom: 'Reason for canceling the ransom',
      rejectionReason: 'Rejection reason',
      returnReason: 'Return reason',
      rollsPlacementTypes: 'Rolls placement types in the car',
      sealNumber: 'Seal №',
      separationType: 'Separation type',
      shippingCancellationReason: 'Shipping cancellation reason',
      shippingDate: 'Shipping document date',
      shippingOnBoards: 'Method of loading into railcar',
      storage: 'Storage',
      ttn: 'Waybill number',
      ttnDate: 'Waybill date',
      veichleNumber: 'Veichle № '
    },
    textTable: {
      qcId: 'Quality sertificate №',
      cgId: 'Batch №',
      driverNameShort: 'Driver name',
      actualPieceId: 'Piece №',
      soLineDescrId: 'Order line',
      weightNetto: 'Net weight, ton',
      weightBrutto: 'Gross weight, ton',
      weightRemain: 'Remain weight',
      quantity: 'Quantity',
      quantityRemain: 'Remains',
      unitShort: 'Units of measurement',
      shiptoStationNameSo: 'Сountry of destination',
      pieceNumId: 'Piece Key',
      qcShopCode: 'Shipping shop code',
      qcDate: 'Quality sertificate date',
      psStatusNumId: 'ID Piece status',
      psStatusName: 'Piece status',
      soDescrId: '№ of Order',
      l4SoId: 'System sales order №',
      zzordOtsortConf: 'Attribute of safe storage from the Order',
      productGroupDescription: 'Product',
      heatId: 'Heat №',
      thick: 'Thickness, mm',
      width: 'Width, mm',
      widthFact: 'Actual width',
      length: 'Length, mm',
      vehicleId: 'Veichle № ',
      customerName: 'Cargo receiver RUS.',
      customerNameEng: 'Cargo receiver EN.',
      shiptoAddressSo: 'Recipient address RUS.',
      shiptoAddressEnSo: 'Recipient address EN.',
      shiptoStationCodeSo: 'Destination indicator',
      shiptoRailwayNameSo: 'Destination railway',
      knotPurposeSo: 'Target node',
      shippingPointNumId: 'Dispatch point',
      sapId: 'SAP Piece №',
      shipmentModeRequirement: 'Method of shipment',
      planDatePps: 'Planned date of shipment from mill',
      serialId: 'Piece bar code data',
      rejectedFlag: 'Acceptance rejection checkbox ',
      incomingDate: 'Acceptance to the Stockyard date',
      incomingTime: 'Acceptance to the Stockyard time',
      incomingStatus: 'Piece acceptance status',
      documentId: 'Document №',
      returnFlag: 'Return checkbox',
      returnVehicle: 'Return veichle',
      returnReason: 'Return reason',
      returnDate: 'Return date',
      plannerNote: 'Note',
      accountingDate: 'Quality sertificate date',
      vehicleIdIn: ' Incoming vehicle №',
      shippingPoint: 'Shipping point',
      container: 'Container №',
      dateLoadInContainer: 'Container loading date',
      plomba: 'Seal №',
      ttn: '№ TN',
      ttnNum: '№ TTN',
      ttnDate: 'Waybill date',
      vehicleIdOut: 'Shipping vehicle Id',
      shippingDate: 'Shipping Date',
      shippingTime: 'Shipping Time',
      incomingUser: 'Acceptance User',
      stockDescr: 'Stock',
      plantDescr: 'Stock',
      areaDescr: 'Area',
      boxDescr: 'Box',
      qcShopDescr: 'Shipping Shop',
      actualShippingDate: 'Actual Shipping Date',

      deliveryId: 'Supply number',
      productType: 'Product type',
      mcNumId: 'Id Master Coil',
      mcNum: 'Master Coil',
      pfrDescr: 'Profile size',
      kolShtPart: 'Quantity pipes',
      sposobUkladUpakovka: 'Shipment method',
      ordheadText: "SAP manager's note",
      okpoConsignee: 'OKPO consignee',
      tnglConsignee: 'TGNL Consignee',
      innConsignee: 'INN Consignee',
      contractNoLog: "Buyer's contract",
      eskBuyer: "Buyer's ESK",
      eskConsignee: 'Consignee ESK',
      lprio: 'Supply priority',
      shipperName: "Shipper's name",
      buyer: 'Naming the buyer',

      invoice: 'Invoice no. of the first shoulder',
      wadat_ist: 'Invoice date of the first shoulder',
      marka: 'Steel grade',
      stornoFlag: 'QС changed',
      note: 'Comment',
      batchId: 'SAP Batch №',
      endCustomerName: 'End customer',

      nextPlant: 'Next plant',
      freightOrder: 'Freight Order № to stock',
      decision: 'Decision',
      onHoldFlag: 'On hold',
      materialSize: 'Material size',

      hasShippingPlan: 'Scheduled for shipment',
      shippingPlanContainerType: 'Type container',
      shippingPlanDate: 'Scheduled shipment date',
      shippingPlanUserName: 'User name of the housekeeper',
      shippingPlanContainerNumber: 'Container number',
      transpOrder: 'Transporting order number from stock',
      departureDate: 'Date of departure of the barge',
      conservationQmet: 'Conservation type',
      grPoverh: 'Surface group',
      nomProekta: 'Project number',
      remainingTimeProduction: 'Time remaining (production)',
      inco1: 'Incoterms',
      prohibition: 'Prohibition on shipment',
      internalPieceId: 'Internal Piece number',
      vidProd: 'Product type',
      storageTimeCount: 'Storage period',
      remainingTimeCount: 'Time remaining',
      overStorageTimeCount: 'Storage period overdue',
      overStorageDates: 'Date of report storage period overdue (SPO)',
      shippingOnBoards: 'Method of loading into railcar',
      nameOfMaterial: 'Material',
      kdMat: 'Material code',
      kromka: 'Edge',
      containerInspectedFlag: 'Container inspection',
      registerFlag: 'Register flag',
      ttnDocStatusDescr: 'TN status',
      ttnNumId: 'ID TN',
      internalLt: 'Internal LT',
      pfCertNo: 'Semi QC number',
      semiCgId: 'Semi batch №',
      semiActualPieceId: 'Semi peace №',
      productPlanDistr: '№ SKU ПФ',
      pieceId: 'Marking',
      clientArrivalDate: 'Actual arrival date',
      clientDeliveryTime: 'Delivery time',
      accountingDocNumber: 'No. of the accounting document',
      accountingDocDate: 'Date of the accounting document',

      M15M4: {
        m15: 'M-4',
        m15NumId: 'id M-4',
        m15DocStatus: 'id M-4 Doc Status',
        m15Date: 'M-4 date',
        m15DocStatusDescr: 'M-4 status'
      },

      M15BM4: {
        m15b: 'M-4B',
        m15bDate: 'M-4B date',
        m15bDocStatus: 'id M-4 Doc Status',
        m15bDocStatusDescr: 'M-4B status',
        m15bNumId: 'id M-4B'
      },

      MX1M4: {
        documentId: 'M-4',
        mh1NumId: 'id M-4',
        mh1DocStatus: 'id M-4 Doc Status',
        mh1Date: 'M-4 date',
        mh1DocStatusDescr: 'M-4 status',
        departureDate: 'Date of departure of the barge',
        conservationQmet: 'Conservation type',
        costPerTon: 'Cost per ton',
        grPoverh: 'Surface group',
        nomProekta: 'Project number',
        cost: 'Cost'
      },

      consignment: {
        qcId: 'Quality sertificate №',
        cgId: 'Batch №',
        actualPieceId: 'Piece №',
        soLineDescrId: 'Order line',
        weightNetto: 'Net weight, ton',
        weightBrutto: 'Gross weight, ton',
        weightRemain: 'Remain weight',
        quantity: 'Quantity',
        quantityRemain: 'Remains',
        unitShort: 'Units of measurement',
        shiptoStationNameSo: 'Сountry of destination',
        pieceNumId: 'Piece Key',
        qcShopCode: 'Shipping shop code',
        qcDate: 'Quality sertificate date',
        psStatusNumId: 'ID Piece status',
        psStatusName: 'Piece status',
        soDescrId: '№ of Order',
        l4SoId: 'System sales order №',
        zzordOtsortConf: 'Attribute of safe storage from the Order',
        productGroupDescription: 'Product',
        heatId: 'Heat №',
        thick: 'Thickness, mm',
        width: 'Width, mm',
        widthFact: 'Actual width',
        length: 'Length, mm',
        vehicleId: 'Veichle № ',
        customerName: 'Cargo receiver RUS.',
        customerNameEng: 'Cargo receiver EN.',
        shiptoAddressSo: 'Recipient address RUS.',
        shiptoAddressEnSo: 'Recipient address EN.',
        shiptoStationCodeSo: 'Destination indicator',
        shiptoRailwayNameSo: 'Destination railway',
        knotPurposeSo: 'Target node',
        shippingPointNumId: 'Dispatch point',
        sapId: 'SAP Piece №',
        shipmentModeRequirement: 'Method of shipment',
        planDatePps: 'Planned date of shipment from mill',
        serialId: 'Piece bar code data',
        rejectedFlag: 'Acceptance rejection checkbox ',
        incomingDate: 'Acceptance to the Stockyard date',
        incomingTime: 'Acceptance to the Stockyard time',
        incomingStatus: 'Piece acceptance status',
        returnFlag: 'Return checkbox',
        returnVehicle: 'Return veichle',
        returnReason: 'Return reason',
        returnDate: 'Return date',
        plannerNote: 'Note',
        documentId: 'Act of acceptance-transfer-1',
        mh1Date: 'Act of acceptance-transfer-1 date',
        mh1NumId: 'id Act of acceptance-transfer-1',
        mh1DocStatus: 'id Act of acceptance-transfer-1 Doc Status',
        storageTimeCount: 'Storage period',
        remainingTimeCount: 'Time remaining',
        mh3: 'Act of return of inventory items-3',
        mh3NumId: 'id Act of return of inventory items-3',
        mh3DocStatus: 'id Act of return of inventory items-3 Doc Status',
        mh3Date: 'Act of return of inventory items-3 date',
        mh3Status: 'Act of return of inventory items-3 date buying out',
        mh3DocStatusDescr: 'Act of return of inventory items-3 status',
        mh1DocStatusDescr: 'Act of acceptance-transfer-1 status',
        internalPieceId: 'Internal Piece number',
        klPok: 'Zinc coat class',
        cvet: 'Coat color',
        dateOm: 'Date of shipment Severstal',
        accountingDate: 'Quality sertificate date',
        vehicleIdIn: ' Incoming vehicle №',
        shippingPoint: 'Shipping point',
        container: 'Container №',
        dateLoadInContainer: 'Container loading date',
        plomba: 'Seal №',
        ttn: 'Railway waybill number',
        ttnDate: 'Waybill date',
        vehicleIdOut: 'Shipping vehicle Id',
        shippingDate: 'Shipping Date',
        shippingTime: 'Shipping Time',
        incomingUser: 'Acceptance User',
        stockDescr: 'Stock',
        areaDescr: 'Area',
        boxDescr: 'Box',
        qcShopDescr: 'Shipping Shop',
        actualShippingDate: 'Actual Shipping Date',
        freightOrder: 'Freight Order №',
        actualStorageTimeCount: 'Actual storage period',
        endCustomerName: 'End customer',

        deliveryId: 'Supply number',
        productType: 'Product type',
        mcNumId: 'Id Master Coil',
        mcNum: 'Master Coil',
        pfrDescr: 'Profile size',
        kolShtPart: 'Quantity pipes',
        sposobUkladUpakovka: 'Shipment method',
        ordheadText: "SAP manager's note",
        okpoConsignee: 'OKPO consignee',
        tnglConsignee: 'TGNL Consignee',
        contractNoLog: "Buyer's contract and namer",
        eskBuyer: "Buyer's ESK",
        eskConsignee: 'Consignee ESK',
        lprio: 'Supply priority',
        shipperName: "Shipper's name",

        invoice: 'Invoice no. of the first shoulder',
        wadat_ist: 'Invoice date of the first shoulder',
        marka: 'Steel grade',
        stornoFlag: 'QС changed',
        note: 'Comment',
        batchId: 'SAP Batch №',
        nextPlant: 'Next plant',

        /* Поля для склада переработки */
        m15: 'M-15',
        m15NumId: 'id M-15',
        m15DocStatus: 'id M-15 Doc Status',
        m15Date: 'M-15 date',
        m15DocStatusDescr: 'M-15 status',

        m15b: 'M-15B',
        m15bDate: 'M-15B date',
        m15bDocStatus: 'id M-15 Doc Status',
        m15bDocStatusDescr: 'M-15B status',
        m15bNumId: 'id M-15B',

        /* Поля для складов Грайф */
        dateProcessingStart: 'Date processing',
        commonNumber: 'Common number',
        sizes: 'Sizes',

        /* Поле для склада МК-М Самара */
        commonNumberMKM: 'Common number',

        decision: 'Decision',
        onHoldFlag: 'On hold',
        materialSize: 'Material size',

        departureDate: 'Date of departure of the barge',
        conservationQmet: 'Conservation type',
        grPoverh: 'Surface group',
        nomProekta: 'Project number',
        cost: 'Cost',
        vidProd: 'Product type',
        overStorageTimeCount: 'Storage period overdue',
        overStorageDates: 'Date of report storage period overdue (SPO)',
        buyoutDate: 'Date of buyout',
        costPerTon: 'Cost per ton',
        kdMat: 'Material code',

        /* Поля для склада ХАБ */
        statusOfStock: 'Status of stock'
      },

      azh: {
        mh3: 'Act of completion of storage',
        mh3NumId: 'id Act of completion of storage',
        mh3DocStatus: 'id Act of completion of storage Doc Status',
        mh3Date: 'Act of completion of storage date',
        mh3Status: 'Act of completion of storage date buying out',
        azhStatusDescr: 'Act of completion of storage status'
      },

      recycling: {
        productPlanDistr: '№ SKU Piece',
        zdvlOrderNumId: 'ZDVL order',
        zdvlLineId: 'ZDVL line',
        taskNumber: 'Task number',
        taskDate: 'Task date',
        dateProcessingStart: 'Date of transfer for processing'
      }
    },
    textInfoTab: {
      coordinates: 'Сoordinates',
      notCoordinates: 'Do not have the coordinates',
      detailsPiece: 'Piece details',
      historyPiece: 'Piece history',
      coordinatesTS: 'Location',
      pieceInformation: 'Piece information',
      consignee: 'Consignee',
      orderData: 'Order data',
      details: 'Details'
    },
    textTableHistory: {
      accountingDate: 'Date',
      modDatetime: 'Date and time',
      actionNumId: 'Id',
      actionType: 'Type',
      userFullName: 'Full user name',
      userName: 'User name',
      attrbCode: 'Code',
      attrbNumId: 'Id',
      attrbValue: 'Value',
      attrbValueOld: 'Old value'
    },
    textTableProduction: {
      profileSize: 'Profile size',
      dateCK: 'QC date',
      consignmentSAP: 'SAP consignment',
      numberConsignment: 'Consignment number',
      numberUE: 'Number piece',
      statusUE: 'Status piece',
      weightConsignment: 'Consignment weight',
      orderZDVL: 'ZDVL order',
      positionZdvl: 'ZDVL position',
      height: 'Height',
      thickness: 'Thickness',
      steelGrade: 'Steel grade',
      normativeDocument: 'Normative document',
      amount: 'Amount',
      CK: 'CK',
      readyWeightNetto: 'Quantity ready product teor.',
      readyWeightOff: 'Quantity ready product fact.',
      weight: 'Weight',
      weightRest: 'Weight rest',
      weightCut: 'Weight cut',
      weightDO: 'Weight DO',
      weightWriteOf: 'Weight write-Of',
      wastePercent: 'Waste percent'
    },
    textTableRecyclingOrders: {
      acceptanceDate: 'Acceptance date (by M-4)',
      accountingDate: 'Quality Certificate  Date (coil)',
      batchId: 'SAP batch',
      capacityAccepted: 'Confirmed (transferred to SAP)',
      capacityAvailable: 'Available for production',
      capacityPipe: 'Volume of pieces',
      semiWidth: 'Width',
      semiThickness: 'Thickness',
      capacityTied: 'Total of binded to Order production',
      capacityPipeMeasureShort: 'Units of measurement to Order production',
      capacityEndProduct: 'Inserted Output quantity',
      cgId: 'Batch #',
      capacityPipeMeasure: 'Capacity FP Measure',
      clientName: 'Customer name',
      contractDate: 'Contract Date',
      contractId: 'Contract number',
      customerName: 'Customer Name',
      executorName: 'Executor Name',
      expireDate: 'Processing order end date',
      lengthCoil: 'Length SF',
      lengthPipe: 'Length FP',
      lineId: 'Order item number in SAP ERP',
      lineStatus: 'Line Status',
      lineStatusTitle: 'Order item status',
      markCoil: 'SF steel grade',
      markPipe: 'FP steel grade',
      matnrComponentsText: 'SF Material',
      matnrGpText: 'FP Material',
      matnrGp: 'FP Material code',
      orderDate: 'Order Date',
      orderId: 'Order number',
      orderStatus: 'Order Status',
      orderStatusTitle: 'Order Status',
      psStatusName: 'Piece status',
      price: 'Price',
      productGroupDescription: 'Product',
      project: 'Project number',
      qcId: 'Quality Certificate (coil)',
      quantity: 'Quantity',
      quantityRemain: 'Remains',
      rolls: 'Rolls',
      sizeCoilMeasure: 'Size SF Measure',
      sizePipe: 'Size FP',
      sizePipeMeasure: 'Size FP Measure',
      skuCoil: 'SKU SF',
      skuCoilId: 'id SKU SF',
      thicknessPipe: 'Thickness FP',
      widthPipe: 'Width FP',
      skuPipe: 'SKU FP',
      skuId: 'id SKU FP',
      standardCoil: 'Standard SF',
      standardPipe: 'Standard FP',
      ueNumber: 'Piece #',
      unitShort: 'Units of measurement',
      weightNetto: 'Weight, t',
      weightRemain: 'Backweight, t',
      weightTrim: 'Сutoff piece weight, t',
      weightWaste: 'Waste weight, t',
      weightEndProduct: 'Finished product weight, t',
      weightCoil: 'Weight SF',
      weightCoilMeasure: 'Weight SF Measure',
      widthCoil: 'Width SF',
      zdvlOrderLineId: 'Order item number',
      zdvlOrderNumId: 'ZDVL Order Num Id',
      zdvlLineNumId: 'ZDVL Line Num Id',
      zdvlLineId: 'Item number of the processing order',
      thick: 'Thickness SF',
      width: 'Width SF',
      taskNumber: 'Task number',
      taskDate: 'Task date',
      additionalStatus: 'Additional status',
      kromka: 'Edge',
      quantityOff: 'Weight netto (count)',
      l4SoId: '№ sales order',
      noticeDatetime: 'Notice datetime',
      plantDescr: 'Stock',
      batchIds: 'SAP batches of semi pr.'
    },
    textTableSO: {
      batchId: 'Batch number',
      conditionOfShipmentName: 'Condition of shipment',
      consignee: 'Consignee',
      createDate: 'Create date',
      customer: 'Customer',
      depositor: 'Shipper (Seller) short name',
      materialText: 'Material',
      pieceId: 'Piece number',
      pieceStatusName: 'Piece status',
      qcId: '№ CQ RP',
      reasonForTheBan: 'Reason for the ban',
      salesOrderLineCurrentCapacity: 'Quantity of the binded RP (current)',
      salesOrderLineMaxCapacity: 'Quantity of RP (max)',
      salesOrderLineMinCapacity: 'Quantity of the binded RP (min)',
      salesOrderLineName: 'Material',
      salesOrderLineNominalCapacity: 'Quantity of the binded RP (nominal)',
      salesOrderLineNum: '№ position',
      salesOrderLineRemainsCapacity: 'Available for binding (remainder)',
      salesOrderNum: '№ order',
      salesOrderSystemNum: '№ order system',
      sapId: 'SAP batch',
      shiptoRailwayCodeSo: 'Railway transport agency',
      shiptoRailwayNameSo: 'Name of the railway',
      shiptoStationCodeSo: 'Destination station',
      shiptoStationNameSo: 'Name of the destination station',
      soLineNum: '№ sales order position',
      soNum: '№ sales order',
      sortingType: 'Type of sorting',
      specDate: 'Specification date',
      statusName: 'Status',
      thickness: 'Thickness',
      weight: 'Quantity',
      width: 'Width',
      zdvlOrderNum: '№ recycling order',
      zdvlOrderLineNum: '№ пrecycling order position'
    },
    textTableAdminMessages: {
      modDateTime: 'Modify date',
      modUserId: 'ID last message author',
      msgDateTime: 'Time of message',
      msgCounter: 'Id message',
      msgId: 'Type',
      status: 'Status',
      clientId: 'Id client',
      msgGuid: 'GUID',
      statusDesc: 'Status description',
      msgDesc: 'Type description',
      msgRemark: 'Error text',
      evnCounter: 'Id internal',
      attemptsCount: 'Attempts count',
      errorText: 'Error text',
      queueId: 'Queue id',
      sapGuid: 'GUID',
      msgSapId: 'GUID',
      msgReprocessNr: 'Reprocess count',
      docId: 'Document number'
    },
    textTableAdminMailing: {
      attachments: 'Attachments',
      body: 'Message body',
      destinationEmail: 'Destination',
      error: 'Error',
      modDateTime: 'Send date',
      modUser: 'User full name',
      senderEmail: 'Sender',
      status: 'Status',
      subject: 'Subject'
    },
    textTableAdminActs: {
      creationUser: 'User full name',
      docDate: 'Act date',
      docId: 'Act number',
      docNumId: 'Act id',
      docStatus: 'Status id',
      docStatusDesc: 'Status',
      docType: 'Type',
      docTypeNumId: 'Type id',
      eventId: 'Message id',
      eventStatus: 'Message status',
      extGuid: 'GUID extrenal',
      extSign: 'Sign external',
      extSignDatetime: 'Sign external date',
      guid: 'GUID',
      inSign: 'Sign inner',
      inSignDatetime: 'Sign inner date',
      modDatetime: 'Modify date',
      modUser: 'Modify user',
      stockDescr: 'Plant id'
    },
    workingDetailing: {
      deleteCommit: 'Delete a comment?',
      notData: 'No data to display',
      deleteSelectPhoto: 'Delete selected photos?',
      deleteText: 'Delete',
      labelEmail: 'Email title',
      errorSubject: 'Enter a title',
      labelEmailTo: "Recipient's Email",
      errorEmailTo1: "Enter the recipient's email address",
      errorEmailTo2: 'Email entered incorrectly',
      labelBody: 'Email Body',
      errorBody: 'Enter the message body',
      commit: 'Comment',
      save: 'Save',
      photo: 'Photo',
      files: 'Files',
      allowedTypes: 'Allowed File Types:',
      send: 'Send',
      sendToEmail: 'Send to email',
      textPhoto: 'Check the boxes for the photos that you want to send',
      decision: 'Decision',
      holdOn: 'Hold on',
      accept: 'Accept',
      decline: 'Decline',
      acceptDecision: 'Decision accepted',
      declineDecision: 'Decision declined'
    },
    textTableTasks: {
      mark: 'Mark',
      profileSize: 'Profile size',
      readyProductSum: 'Ready pr.',
      remain: 'Remain',
      semiProductSum: 'Semi pr.',
      sku: 'SKU',
      sum: 'Summary',
      taskNumId: 'ID task',
      taskNumber: 'Task number',
      taskDate: 'Task date',
      matnrGpText: 'FP Material',
      statusName: 'Status',
      plantDescr: 'Stock'
    },
    production: {
      deleteConfirmation: {
        deleteConfirmationP1:
          'Are you sure you want to delete the batch of ready №',
        deleteConfirmationP2: 'in'
      },
      inputTrim: 'Input trim',
      inputWaste: 'Input waste',
      inputReady: 'Input ready',
      inputUndercut: 'Input undercut',
      semiTab: 'Input the fact of prod. (working with semi)',
      inputAllWaste: 'Input all waste',
      undectutConfirmTab: 'Undercut confirmation',
      readyTab: 'Input the fact of prod. (working with ready)',
      readyConfirmationTab: 'Input the fact of production'
    },
    directions: {
      MET_SAP: 'MES to SAP',
      C1_MET: '1C to MES',
      MET_1C: 'MES to 1C',
      SAP_MET: 'SAP to MES'
    },
    messageTypeFilter: {
      C1_MET: {
        N: 'No value',
        9003: 'Application for an act',
        9008: 'Production',
        9009: 'Shipment'
      },

      SAP_MET: {
        N: 'No value',
        4307: 'Cutting table',
        4332: 'Act sign',
        4334: 'Entrance',
        4338: 'ZDVL order',
        4339: 'Vehicle dislocation TM',
        4340: 'Railway dislocation',
        4341: 'Railway dislocation',
        4342: 'Sales order',
        6301: 'Freight order from TM',
        6405: 'Multi-section barge'
      },

      MET_SAP: {
        N: 'No value',
        4337: 'Document for EDI',
        4338: 'TTN',
        4339: 'ZDVL sign',
        4340: 'QC status for TM',
        4341: 'Moving around the off-balance sheet',
        4342: 'Production',
        4343: 'Undercuts'
      },

      MET_1C: {
        N: 'No value',
        9003: 'Act sign',
        9008: 'Production',
        9009: 'Shipment'
      }
    },
    filters: {
      codeType: 'Message type',
      codeStatus: 'Message status',
      dateEnd: 'Date to',
      dateFrom: 'Date from',
      numberEnd: 'Number to',
      numberFrom: 'Number from',
      docId: 'Document id'
    },
    support: {
      notData: 'No data to display',
      photo: 'Photo',
      add: 'Add',
      message: 'Contacting the support service',
      errorMessage: 'The appeal should not be empty',
      send: 'Send'
    },
    administrationTabs: {
      signPopup: {
        enterName: 'Enter name',
        enterDate: 'Enter date'
      },
      buttons: {
        sign: 'Sign',
        cancelSign: 'Cancel sign',
        resend: 'Retry send',
        changeStatus: 'Change status',
        changePlant: 'Change plant'
      },
      tabs: {
        userAdmin: 'Users',
        pieces: 'Pieces manager',
        messages: 'Messages',
        mailing: 'Mailing',
        acts: 'Acts',
        contracts: 'Contracts'
      }
    },
    searchBar: {
      placeholder: 'Enter keyword...',
      filter: 'Filter',
      searchButton: 'Search',
      filterSettings: 'Filter settings',
      placeholderPlant: 'Enter the name of the warehouse....'
    },
    task: {
      textSemiHeading: 'ZDVL rolls'
    },
    undercutTab: {
      deleteUndercutConfirm: 'Are you sure you want to remove the undercut?',
      selectedUndercut: 'Selected roll',
      typeUndercut: 'Undercut type',
      selectUndercutType: 'Select undercut type',
      cuttings: 'Undercut lines'
    },
    wasteBalalancingTotalAverage: 'Total. average',
    textVisit: {
      userName: 'User name',
      fullName: 'Full name',
      plantShortDescr: 'Stock',
      sessionStart: 'Start time',
      sessionEnd: 'End time'
    },
    adminPanel: {
      textDeleteContract: 'Are you sure you want to delete the contract',
      textDeleteContractTitle: 'Contract delete',
      textAddContractTitle: 'Add contract',
      textUpdateContractTitle: 'Contract update',
      contractNumId: 'Contract ID',
      contractNumberSys: 'Contract number system',
      contractNumberLog: 'Contract number logic',
      contractDate: 'Contract date'
    },
    stockConfigure: {
      plant: 'Stock',
      area: 'Area',
      box: 'Box',
      collapseAll: 'Collapse all',
      expandAll: 'Expand all',
      addArea: 'Add area',
      addBox: 'Add box',
      deleteLevel: 'Delete level',
      editLevel: 'Edit level',
      noParentDesc: 'No parent',
      description: 'Name',
      configCode: 'Stock config code',
      parentLevel: 'Parent level',
      holderId: 'Holder code',
      sapCode: 'SAP code',
      deleteConfirm: 'Are you sure you want to delete level'
    },
    textTN: {
      additionalData: 'Additional data',
      dateTN: 'TN date',
      docNum: 'Document No',
      docType: 'Document type',
      driverData: 'Driver data',
      driverMiddleName: 'Middle name',
      driverName: 'First name',
      driverLastName: 'Last name',
      note: 'Note',
      numberTN: 'TN number',
      packingType: 'Packing type',
      selectTN: 'Select TN',
      select: 'Select',
      vehicleData: 'Vehicle data',
      vehicleNum: 'Vehicle number',
      vehicleModel: 'Vehicle model',
      vehicleType: 'Vehicle type',
      driverDocumentNumber: 'Document number',
      familyName: 'Last name',
      givenName: 'First name',
      middleName: 'Middle name',
      driverDocumentType: 'Document type',
      passport: 'Passport',
      driverLicense: 'Driver license',
      selectDocumentType: 'First select document type',
      selectVehicleType: 'First select vehicle type',
      auto: 'Car',
      trailer: 'Trailer',
      isExpeditor: 'Is expeditor',
      trailerNum: 'Trailer number',
      separationWeight: 'Separation weight, kg',
      supportingDocuments: 'Supporting documents',
      supportingDocumentsValue: 'TN, acts, certificates',
      supportingDocumentsEmpty: 'Empty',
      responsiblePersonData: 'Data of responsible person sender side',
      responsiblePersonFullName: 'Full name',
      responsiblePersonPost: 'Position',
      transportCompanyData: 'Transport company',
      transportCompanyName: 'Name',
      inn: 'INN',
      address: 'Address'
    },
    textTnColumn: {
      accountingDate: 'Accounting date',
      actualPieceId: 'Piece ID',
      actualShippingDate: 'Actual shipping date',
      address: 'Address',
      cgId: 'CG ID',
      docStatus: 'TN status',
      docStatusDescr: 'TN Status',
      documentType: 'Document type',
      documentNumber: 'Document number',
      driverNameShort: 'Driver name',
      expeditorFlag: 'Expeditor',
      familyName: 'Last name',
      fullName: 'Full name',
      givenName: 'First name',
      grossWeight: 'Gross weight, t',
      inn: 'INN',
      middleName: 'Middle name',
      netWeight: 'Netto weight, t',
      packingType: 'Name',
      position: 'Position',
      psStatusName: 'PS status',
      qcId: 'QC ID',
      transportCompanyName: 'Name',
      ttnDocumentDate: 'Date TN',
      ttnDocumentId: 'TN number',
      ttnDocumentNumId: 'id TN',
      vehicleBrand: 'Vehicle brand',
      vehicleId: 'Vehicle number',
      vehicleNum: 'Vehicle number',
      vehicleType: 'Vehicle type',
      weight: 'Weight',
      weightSeparation: 'Weight separation, kg'
    },
    tnStatus: {
      created: 'Created',
      show: 'Formed',
      confirm: 'Confirmed'
    }
  },

  ru: {
    downloadMobileVersion: 'Скачать мобильную версию',
    news: 'Новости',
    userManual: 'Инструкция пользователя',
    textLocal: 'Язык интерфейса',
    textThemes: 'Темная тема',
    exit: 'Выход',
    // ***
    severstalInfocom: 'Северсталь-Инфоком',
    login: 'Войти',
    welcome: 'Добро пожаловать',
    textIncorrect:
      'Данные введены некорректно или вашей учетной записи не существует в корпоративной сети.\nПожалуйста, повторите попытку или свяжитесь со службой поддержки',
    unauthorized: 'Для получения запрашиваемого ответа нужно ввести логин и пароль для входа на сайт',
    requestTimeout: 'Время ожидания истекло. Пожалуйста, проверьте стабильность соединения и попробуйте еще раз',
    gatewayTimeout: 'Сервер не может связаться с запрашиваемым ресурсом в данный момент, либо время ожидания ответа истекло',

    name: 'Имя',
    password: 'Пароль',
    loading: 'Загрузка...',
    textErrorName: 'Введите Имя пользователя',
    textErrorPassword: 'Введите пароль',
    textTitleAuth: 'Работа с удаленным складом',
    textSupportPhone: 'Телефон службы поддержки',
    textFooterLeftStart: '© 2020-',
    textFooterLeftFinish: ' “Северсталь”. Все права защищены',
    textFooterRight: 'Написать в службу поддержки',
    textSelectStock: 'Выберите склад',
    textContinue: 'Продолжить',
    textBindChangeRolls: 'Привязать/Изменить ПФ',
    textBindChangeProducts: 'Привязать/Изменить ГП',
    textTabRecyclingOrders: 'Заказы на переработку',
    textTabSO: 'Заказы',
    textTabTasks: 'Задания',
    textTabListMetalAvailable: 'Наличие металла',
    textTabListMetalReport: 'Получение металла',
    textTabListWasteBalancing: 'Балансировка отходов',
    textTabListReports: 'Отчеты',
    textTabListProduction: 'Производство',
    textTabListStockMetrics: 'Метрики по складу',
    textTabListScanning: 'Сканирование',
    textTabListResponsiblePersons: 'Ответственные лица',
    textTabListStock: 'Склад',
    textTabListEditAct: 'Редактирование акта',
    textTabEditTtn: 'Работа с ТН',
    textTabUserManual: 'Редактор инструкций',
    textSurveyTab: 'Опросы пользователей',
    textReport: [
      'Справка о движении Товара на складе хранения',
      'Отчет хранителя',
      'Реестр актов',
      'План погрузки',
      'Инвентаризация',
      'Движение металла',
      'Инвентаризационная опись "ИНВ-3"',
      'Сверхнормативное хранение',
      'Отчет по готовой продукции',
      'План выхода с производства',
      'Отчет по возвратам',
      'Отчет по ТН',
      'Отчет по карантинам',
      'Отчёт переработчика',
      'Реестр печатных актов'
    ],
    textReportCalculationPay: {
      name: 'Расчет вознаграждения хранителя',
      data: ['Весь металл в наличии', 'Только выкупленный']
    },
    textReportTypeAct: {
      name: 'Типы актов',
      data: ['Все акты', 'Только не обработанные', 'Только подписанные']
    },
    error: 'Ошибка',
    textReportSuccess: 'Отчет успешно сформирован',
    textReportName: 'Наименование отчета',
    textReportDross: 'Окалина, тн',
    textSelectPeriod: 'Выберите корректный период',
    textSelectDate: 'Выберите дату',
    textReportNumber: 'Номер отчета',
    textSelectUser: 'Выберите пользователя',
    textSelectAct: 'Выберите тип акта',
    textSelectDateTime: 'Выберите дату',
    textTypeProduct: 'Выберите тип продукта',
    textActSendSuccess: 'Акт был успешно отправлен поклажедателю',
    textPeriodAcceptance: 'Период приëмки',
    textShipmentPeriod: 'Период отгрузки',
    textRedemptionPeriod: 'Период выкупа',
    textRecyclingPeriod: 'Период переработки',
    textPeriod: 'Период',
    textStock: 'Склад',
    textSelectItem: 'Выберите значение',
    textСost: 'Ставка (₽ руб.)',
    textArrivalDate: 'Дата прибытия груза',
    textButton: {
      all: 'Все',
      add: 'Добавить',
      addHolderReport: 'Новый',
      addReady: 'Добавить',
      addSurvey: 'Создать опрос',
      addToReportOverStorageDates: 'Добавить в Св.Н отчет',
      back: 'Назад',
      bind: 'Привязать',
      bind_unbind: 'Привязать/Отвязать',
      buyOut: 'Выкупить',
      cancel: 'Отмена',
      cancelPlanning: 'Отмена плановой погрузки',
      cancelProcessing: 'Отмена переработки',
      cancelSend: 'Отменить отправку в SAP',
      cancelShipment: 'Отменить отгрузку',
      checkXml: 'Посмотреть XML',
      close: 'Закрыть',
      closeOrder: 'Закрыть заказ',
      confirm: 'Подтвердить',
      continue: 'Продолжить',
      create: 'Сформировать',
      createChapter: 'Создать раздел',
      createManual: 'Создать инструкцию',
      createTask: 'Задание',
      delete: 'Удалить',
      deleteScanedPiece: 'Удалить из списка',
      downloadQc: 'Скачать СК',
      edit: 'Редактировать',
      export: 'Выгрузить',
      forward: 'Вперёд',
      inputAllWaste: 'Ввод отходов',
      inputData: 'Ввести данные',
      inputReady: 'Ввод ГП',
      inputTrim: 'Ввод обрези',
      inputUndercut: 'Ввод подкроя',
      inputWaste: 'Ввод ДО',
      inStock: 'В наличии',
      inTransit: 'В пути',
      loadingPlanning: 'Планирование погрузки',
      no: 'Нет',
      passLater: 'Пройти позже',
      passNow: 'Пройти сейчас',
      placeStock: 'Разместить на склад',
      preview: 'Просмотр',
      print: 'Печать',
      printQcFromQmet: 'Печатать с перегрузом',
      printQcFromStorage: 'Печатать оригинал',
      processing: 'Переработать',
      rebinding: 'Перепривязать',
      reject: 'Отклонить',
      returned: 'Возвращен',
      refuseAcceptance: 'Отказаться от приёмки',
      remove: 'Удалить',
      removeFromAct: 'Удалить из акта',
      removeFromActM15: 'Удалить из М15',
      reset: 'Сбросить',
      rid: 'Освободить',
      save: 'Сохранить',
      send: 'Отправить',
      shipped: 'Отгружен',
      storno: 'Сторнировать',
      submerge: 'Погрузить',
      subscribe: 'Подписать',
      textOpen: 'Открыть',
      textReturn: 'Возврат',
      toShip: 'Отгрузить',
      toMount: 'на монтаж',
      toUnmount: 'снять с монтажа',
      ttnCreate: 'Формирование ТН',
      ttnUpdate: 'Обновить ТН',
      writeOff: 'Списать',
      yes: 'Да',
      yesCancel: 'да, отменить',
      doNotShowAgain: 'Больше не показывать',
      complete: 'Завершить',
      resume: 'Возобновить',
      copyAll: 'Скопировать всё',
      copied: 'Скопировано',
      notification: 'Уведомление'
    },
    textDataGrid: {
      alreadySelected: 'Уже выбрано',
      availableForBinding: 'Доступно к привязке',
      capacityPipe: 'объем ГП',
      exportExcel: 'Выгрузка в Excel',
      gross: 'брутто',
      nett: 'нетто',
      pcs: 'шт',
      pieceQU: 'Количество УЕ',
      quantity: 'кол-во',
      quantityRemain: 'кол-во, ост.',
      selectOrders: 'Выбрано позиций',
      selectedSum: 'сумма',
      selectQU: 'Выбрано УЕ',
      textSearch: 'Поиск',
      textTotal: 'Всего',
      tonne: 'тонн'
    },
    textError: {
      addFile: 'Добавьте файл',
      cannotProcess: 'Сервер не может обработать запрос, попробуйте позже',
      contactSupport: 'обратитесь в службу поддержки',
      detail: 'Подробнее',
      differentShiptoAddressSo:
        'Один акт не может включать в себя учетные единицы с разными адресами грузополучателя',
      differentWarehousesSelected: 'Выбраны разные склады',
      endSession: 'Ваша сессия работы в МЕС УС завершилась.\nДля продолжения работы авторизуйтесь повторно.',
      enterActualShippingDate: 'Введите дату фактической отгрузки',
      enterContainerNumber: 'Введите номер контейнера',
      enterDate: 'Введите дату',
      enterDateLoadingContainer: 'Введите дату погрузки в контейнер',
      enterDateRange: 'Не указан диапазон дат',
      enterDescription: 'Введите описание',
      enterDocumentNum: 'Введите номер документа',
      enterMH3Number: 'Укажите номер акта МХ-3',
      enterNumberRailShippDoc: 'Введите номер ж/д накладной или ТН',
      enterPieceId: 'Введите номер УЕ',
      enterQcId: 'Введите номер СК',
      enterQRCode: 'Отсканируйте qrcode или введите его',
      enterQuantityOff: 'Введите фактическое кол-во',
      enterQuantity: 'Введите теоретическое кол-во',
      enterSealNumber: 'Введите номер пломбы',
      enterShippingCancellationReason: 'Введите причину отмены отгрузки',
      enterShippingDate: 'Введите дату накладной',
      enterReasonForCancelingRansom: 'Введите причину отмены выкупа',
      enterRejectionReason: 'Введите причину отказа',
      enterTtnDate: 'Введите дату ТН',
      enterVeichle: 'Введите номер ТС',
      errorLoadQC: 'Ошибка загрузки выбранных СК',
      fieldNotFilled: 'Поле не заполнено',
      gatewayTimeout: 'Сервер не может связаться с запрашиваемым ресурсом в данный момент, либо время ожидания ответа истекло.',
      incorrectDateRange: 'Не верный диапазон дат',
      mustSelectPrintQCSource: 'Необходимо выбрать источник печати СК',
      needTtn: 'Операция не сохранена, требуется вложить ТН',
      noMatchingOrder: 'В наличии нет подходящего заказа',
      noValueSelected: 'Не выбрано значение',
      parametersSelectProductDoNotMatch: 'Не совпадают параметры выбранной продукции',
      reportCreateError: 'Ошибка при формировании отчета',
      requestTimeout: 'Время ожидания истекло. Пожалуйста, проверьте стабильность соединения и попробуйте еще раз.',
      selectPlants: 'Не выбран ни один склад',
      selectZdvlLineNumId: 'Выберите позицию заказа',
      serviceUnavailable: 'МЕС УС в данный момент недоступен, обратитесь в службу поддержки.',
      setRealPriorityShippingDays: 'Количество дней для 2-го приоритета должно быть всегда меньше, чем для 1-го',
      textErrorDeleteMessage: 'Ошибка удаления новостного сообщения, обратитесь в службу поддержки',
      textErrorFifo: 'Необходимо выбрать ПФ согласно модели FIFO',
      textErrorNotEnoughSemi: 'Недостаточно полуфабриката для выполнения задания',
      textIncorrect:
        'Данные введены некорректно или вашей учетной записи не существует в корпоративной сети.\nПожалуйста, повторите попытку или свяжитесь со службой поддержки.',
      textSymbolsLimitMh3: 'Поле "№ МХ-3/Акт о завершении хранения" не может содержать более 50 символов',
      unauthorized: 'Для получения запрашиваемого ответа нужно ввести логин и пароль для входа на сайт.',
      unknownError: 'Неизвестная ошибка - обратитесь в службу поддержки',
      useMCnotFTO:
        'При выбранном условии "Использование мастер-рулонов" нельзя включать "Склад ГП/ПФ" и наоборот',
      useM15BWithoutM15: 'М15В нужно использовать с М15',
      useWithoutAutoShipmentCondition: 'Данная настройка должна работать с выключенной настройкой - Автоматическое определение условия отгрузки',
      useWithoutShippingVehicleOnly: 'Данная настройка должна работать с выключенной настройкой - Использование только № ТС и даты фактической отгрузки',
      vehicleNumFormat1: 'Введённый номер',
      vehicleNumFormat2: 'не соответствует формату',
      vehicleNumFormat3: 'При отгрузке на авто требуется ввести номер ТС в формате "Номер тягача/номер прицепа". Например, А123АА123/АА123456.',
      warning: 'Предупреждение',
      wasteWithSemi: 'Необходимо заполнить оба поля "Кол-во выпуска отходов" и "Кол-во списания ПФ"'
    },
    dataSuccess: 'Данные успешно обновлены',
    textSuccess: 'Успешно',
    textAlreadyFound: 'Уже найдено',
    textNoData: 'Нет данных',
    pieceStatusChanged: 'Статус УЕ изменен',
    taskStatusChanged: 'Статус задания изменен',
    actsSigned: 'Акты подписаны',
    textModal: {
      addPiece: 'Добавить УЕ',
      addReportOverdue: 'Добавить в отчёт свехнормативного хранения',
      attachedFile: 'Приложенный файл',
      buyMetal: 'Выкуп металла',
      cancellationOfLoading: 'Отмена погрузки',
      cancellationOfRedemption: 'Отмена выкупа',
      cancellationOfProcessing: 'Отмена переработки',
      createTN: 'Оформление ТН',
      deleteAct: 'Удаление акта',
      deletePiece: 'Удалить УЕ',
      deleteReport: 'Удаление отчета',
      description: 'Описание',
      nameChapter: 'Название раздела',
      nameManual: 'Название инструкции',
      refusalToAccept: 'Отказ от приемки',
      placementStock: 'Размещение на склад',
      metalReceiving: 'Приемка металла',
      metalProcessing: 'Переработка металла',
      selectQU: 'Выбранные учетные единицы',
      surveyEndDate: 'Дата окончания опроса',
      surveyStartDate: 'Дата начала опроса',
      surveyTitle: 'Описание опроса',
      loadingMetal: 'Погрузка металла',
      rebindingSZ: 'Перепривязка СЗ',
      returnMetal: 'Возврат металла',
      returnType: 'Тип возврата',
      textBindRolls: 'Привязать выбранные рулоны?',
      textRidRolls: 'Отвязать ПФ по завершении производства?',
      textActErrorLeft: 'На выбранные учетные единицы акт(ы)',
      textActErrorRight: 'уже сформирован и отправлен. Чтобы включить учетные единицы в новый акт, необходимо удалить их из существующего акта.',
      textActErrorMx1Left: 'На выбранные учетные единицы',
      textActErrorMx1Right: 'не оформлен или не подписан акт МХ-1 (М-4)',
      textActErrorMx3Left: 'Данный СК №',
      textActErrorMH3NotSent: 'Напоминаем, что следующие акты МХ-3 не отправлены в ПАО «Северсталь»',
      textActErrorMx3Center: 'уже включен в акт №',
      textActErrorMx3Right: 'Для того, что бы сменить изменить номер акта, необходимо данный СК удалить из акта №',
      textZeroWeightRemainErrorLeft: 'Выкуп невозможен для СК:',
      textZeroWeightRemainErrorRight: 'так как остаточное количество полуфабриката равно 0',
      textCreateSk: 'Сформировать СК',
      textCreateAct: 'Сформировать акт',
      textCreateInvoice: 'Сформировать накладную',
      textBailorSendAct1Left: 'Подписать и направить акт',
      textBailorSendReport: 'Подписать и отправить Отчет хранителя',
      textBailorSendAct1Right: 'поклажедателю?',
      textBailorSendAct2Left: 'Открыть акт',
      textBailorSendReportSent: 'Открыть отчет',
      textHolderReport: 'Отчет хранителя',
      textBailorSendAct2Right: 'или повторно отправить поклажедателю?',
      textBailorSendInvoice1Left: 'Подписать и направить накладную',
      textBailorNotSigned: 'Вы не подписали акт',
      textBailorSendInvoice1Right: 'поклажедателю?',
      textBailorSendInvoice2Left: 'Открыть накладную',
      textBailorSendInvoice2Right: 'или повторно отправить поклажедателю?',
      textQRCode: 'Сканирование продукции',
      textQRCodeCamera: 'Наведите камеру на QR, штрих-код или DataMatrix',
      textIncomingF1Left: 'СК №',
      textIncomingF1Right:
        'был ФИЗИЧЕСКИ возвращён в цех. Свяжитесь с цехом отгрузки',
      textIncomingF2Left: 'На СК №',
      textIncomingF2Right:
        'был оформлен ЛОГИЧЕСКИЙ возврат в цех. Свяжитесь с цехом отгрузки',
      textMPLeft: 'Данная УЕ в составе Мастр-рулона №',
      textMPRight: 'Используйте Мастер-рулон',
      textIncomingHoldLeft: 'СК №',
      textIncomingHoldRight: 'был добавлен в карантин',
      textIncomingNoSoDescrLeft: 'У СК №',
      textIncomingNoSoDescrRight:
        'отсутствуют данные по заказу. Отгрузить невозможно!',
      fromAct: 'из акта(ов)',
      respectively: 'соответственно',
      textSubscribe: 'Сформировать спецификацию (ии) на заказ (ы)',
      textReject: 'Отклонить подписание выбранных позиций:',
      textSignAndSend: 'Подписать и отправить',
      textSignAndSendOrder: 'Подписать и отправить заказ №',
      textRejectOrderAcceptance: 'Отклонить приемку заказа №',
      textRejectOrderAcceptanceTitle: 'Отклонить приемку заказа',
      textShipmentPlanning: 'Планирование отгрузок',
      textShipmentPlanningCancel: 'Отмена планированной отгрузки',
      textOpen: 'Открыть',
      textOpenOrder: 'Открыть заказ',
      textShipmentCheckFIFO: 'Проверка соответствия принципу FIFO',

      selectQUCheckFIFO:
        'Выбранные учетные единицы не удовлетворяли FIFO, продолжить с нижеуказанными?',
      continue: 'Продолжить',
      exportPDF: 'Выгрузить в PDF',
      exportExcel: 'Выгрузить в EXCEL',
      noteText: 'Особые отметки',
      noteTextSave: 'Особые отметки сохранены',
      textDifferentHoldFlag:
          'Для дальнейшей операции необходимо выбрать УЕ либо только в карантине, либо не в карантине',
      textDifferentQCShipment:
          'Вы выбрали УЕ производства ЛПЦ-3 и другого цеха, выберите однотипные УЕ или отключите опцию "Использование только № ТС и даты фактической отгрузки"',
      textIncomingProhibitionLeft: 'По заказу №',
      textIncomingProhibitionRight: 'выставлен запрет на погрузку',
      textZdvlCloseP1: 'Вы действительно хотите закрыть заказ(ы) № ',
      textZdvlCloseP2: 'позиция(ии) № ',
      textZdvlClosedWarningP1: 'Выбранная позиция № ',
      textZdvlClosedWarningP2: 'заказа № ',
      textZdvlClosedWarningP3: 'ЗАКРЫТА',
      textAddSemiTask: 'Добавить полуфабрикаты',
      textAddZdvlLine: 'Добавить позицию заказа',
      textDeleteTask: 'Удалить задание',
      textDeleteTaskConfirm: 'Вы действительно хотите удалить задание',
      textStornoHeading: 'Основание сторнирования',
      textStornoInput: 'Введите основание сторнирования',
      textConfirmQC: 'Подтвердить отправку СК',
      textFrom: 'от',
      textModalPrintTasks: 'Задания',
      textModalDate: 'Введите дату',
      textModalDateFrom: 'Дата с',
      textModalDateTo: 'Дата по',
      textSelectSentOnly: 'Нужно выбрать УЕ только в статусе Отправлен',
      textSelect10QCOrLess: 'Необходимо выбрать не более 10 СК',
      youSure: 'Вы уверены',
      textDeleteAct: 'Вы уверены, что нужно удалить документ',
      textDeleteHolderReport: 'Вы уверены, что нужно удалить отчет',
      listPiece: 'Список УЕ',
      textSOBindP1: 'Привязать СК № ',
      textSOBindP2: 'к заказу № ',
      textSOBindP3: 'Отвязать СК № ',
      textSOBindP4: 'от заказа № ',
      textSOBindP5: 'позиция № ',
      textSOMaxToleranceWarn: 'превышен максимальный толеранс.',
      textSOMaxCapacity: 'Максимально возможно привязать: ',
      textSOBinding: 'привязывается: ',
      textSOWrongStatusLeft: 'Привязка к СЗ № ',
      textSOWrongStatusCenter: ' позиции № ',
      textSOWrongStatusRight: ' невозможна. Для привязки ГП(УЕ) статус позиции СЗ должен быть "Принята"',
      textDifferentShipmentMode: 'выбраны УЕ с разными способами погрузки',
      textCheckShipping: 'Проверка данных перед отгрузкой',
      textActStatus: 'Проверьте статусы актов, все акты должны быть в статусе "Сформирован".',
      textUpdateZDVL: 'Обновление заказа на переработку',
      textAddMessage: 'Добавить новость',
      textEditMessage: 'Редактирование новости',
      textMessageShippingType: 'Тип склада',
      textMessageType: 'Тип сообщения',
      textMessageDate: 'Дата сообщения',
      textActiveToDate: 'Актуально до',
      textMessageTitle: 'Заголовок сообщения',
      textMessageText: 'Сообщение',
      signActsByClient: 'Подписать акты',
      textVehicleTn: 'Выбрать Рег№(Авто)',
      textVehicleTnAdd: 'Добавить транспорт',
      textTrailerTn: 'Выбрать Рег№(Прицеп)',
      textTrailerTnAdd: 'Добавить прицеп',
      textDriverTn: 'Выбрать водителя',
      textDriverTnAdd: 'Добавить водителя',
      textPackingTypeTn: 'Выбрать тип упаковки',
      textPackingTypeTnAdd: 'Добавить тип упаковки',
      textTnList: 'Выбрать ТН',
      confirmTn: 'Подтверждение ТН',
      confirm: 'Подтверждение',
      textConfirmTn: 'Вы уверены что хотите подтвердить ТН',
      editTn: 'Редактировать ТН',
      textCreateTn: ' Сформировать ТН',
      textOpenConfirmedTn: 'Открыть ТН',
      deleteTn: 'Удалить ТН',
      textDeleteTn: 'Вы уверены что хотите удалить ТН',
      textResponsiblePersonTn: 'Выбрать ответственное лицо',
      textResponsiblePersonTnAdd: 'Добавить ответственное лицо',
      textNoCapacityAvailable: 'Нет объемов для производства по позиции',
      textNoCapacityAvailableOrder: 'заказа',
      textVideoManuals: 'Видеоинструкция',
      textTransportCompany: 'Выбрать транспортную компанию',
      textTransportCompanyAdd: 'Добавить транспортную компанию',
      serviceQualityAssessment: 'Оценка сервиса МЕСУС',
      textTypeReturnYInfo:
        'Физический возврат - реальный возврат СК в место отгрузки, для доработки, в случае пересорта и т.д.',
      textTypeReturnNInfo:
        'Логический возврат - изменение статуса СК, чтобы цех мог внести изменения в СК, без возврата металла в место отгрузки.'
    },
    textZone: 'Зона',
    textBox: 'Бокс',
    textTypeReturn: {
      y: 'Физический',
      n: 'Логический'
    },
    textData: {
      acceptanceTransfer1Number: '№ МХ-1/М-4',
      acceptanceTransfer15Number: '№ М-15/М-4',
      acceptanceTransfer1and15Number: '№ МХ-1 и № М-15',
      acceptanceTransfer4Number: '№ М-4',
      actualShippingDate: 'Дата фактической отгрузки',
      clientList: 'Список клиентов',
      containerInspectedFlag: 'Контейнер осмотрен, исправен',
      containerNumber: '№ контейнера',
      containerType: 'Тип контейнера',
      contractNumber: '№ Договора',
      date: 'Дата',
      dateLoadingContainer: 'Дата погрузки в контейнер',
      documentForProduction: 'Переместить на договор переработки',
      documentNumber: '№ документа',
      internalPieceNumber: 'Внутренний номер УЕ',
      inventoryItems3Number: '№ МХ-3/Акт о завершении хранения',
      mh3: 'МХ-3',
      nextPlants: 'Следующий экспедитор',
      numberRailShippDoc: '№ ж/д накладной или ТН',
      orderListNumber: '№ СЗ',
      qc: '№ СК',
      reasonForCancelingRansom: 'Причина отмены выкупа',
      rejectionReason: 'Причина отказа',
      returnReason: 'Причина возврата',
      rollsPlacementTypes: 'Расположение рулона в кузове авто',
      sealNumber: '№ пломбы',
      separationType: 'Вид сепарации',
      shippingCancellationReason: 'Причина отмены отгрузки',
      shippingDate: 'Дата накладной',
      shippingOnBoards: 'Способ погрузки в вагон',
      storage: 'Хранение',
      ttn: '№ ТН',
      ttnDate: 'Дата ТН',
      veichleNumber: '№ ТС'
    },
    textTable: {
      qcId: '№ СК',
      cgId: '№ партии',
      driverNameShort: 'ФИО водителя',
      actualPieceId: '№ УЕ',
      soLineDescrId: 'Позиция заказа',
      weightNetto: 'Вес нетто, т',
      weightBrutto: 'Вес брутто, т',
      weightRemain: 'Остаточный вес',
      quantity: 'Количество',
      quantityRemain: 'Остаток',
      unitShort: 'Единица измерения',
      shiptoStationNameSo: 'Ст.назначения',
      pieceNumId: 'Ключ УЕ',
      qcShopCode: 'Код цеха отгрузки',
      qcDate: 'Дата СК',
      psStatusNumId: 'ID статуса УЕ',
      psStatusName: 'Статус УЕ',
      soDescrId: '№ Заказа',
      l4SoId: '№ СЗ сист.',
      zzordOtsortConf: 'Признак ОХ из заказа',
      productGroupDescription: 'Продукт',
      heatId: '№ плавки',
      thick: 'Толщина, мм',
      width: 'Ширина, мм',
      widthFact: 'Фактическая ширина',
      length: 'Длина, мм',
      vehicleId: '№ ТС',
      customerName: 'Грузополучатель рус.',
      customerNameEng: 'Грузополучатель анг.',
      shiptoAddressSo: 'Адрес получателя рус.',
      shiptoAddressEnSo: 'Адрес получателя англ.',
      shiptoStationCodeSo: 'Код станции назначения',
      shiptoRailwayNameSo: 'ЖД назначения',
      knotPurposeSo: 'Целевой узел',
      shippingPointNumId: 'Пункт отправки',
      sapId: '№ УЭ SAP',
      shipmentModeRequirement: 'Способ отгрузки',
      planDatePps: 'Плановая дата отгрузки с комбината',
      serialId: 'Данные штрих кода для УЭ',
      rejectedFlag: 'Флаг отказа от приемки',
      incomingDate: 'Дата приемки на склад',
      incomingTime: 'Время приемки на склад',
      incomingStatus: 'Статус принятия УЕ',
      documentId: '№ Документа',
      returnFlag: 'Флаг возврата',
      returnVehicle: 'ТС возврата',
      returnReason: 'Причина возврата',
      returnDate: 'Дата возврата',
      plannerNote: 'Примечание',
      accountingDate: 'Дата СК',
      vehicleIdIn: '№ ТС первого плеча',
      shippingPoint: 'Пункт отправки',
      container: '№ контейнера',
      dateLoadInContainer: 'Дата загрузки контейнера',
      plomba: '№ пломбы',
      ttn: '№ ТН',
      ttnNum: '№ ТН',
      ttnDate: 'Дата накладной',
      vehicleIdOut: '№ ТС отгруженного с УС',
      shippingDate: 'Дата отгрузки с УС',
      shippingTime: 'Время отгрузки с УС',
      incomingUser: 'ФИО принявшего',
      stockDescr: 'Склад',
      plantDescr: 'Склад',
      areaDescr: 'Зона',
      boxDescr: 'Бокс',
      qcShopDescr: 'Цех-отправитель',
      actualShippingDate: 'Дата фактической отгрузки',

      deliveryId: 'Номер поставки',
      productType: 'Вид продукта (МС для Мастер-рулона)',
      mcNumId: 'Id Мастер-рулона',
      mcNum: 'Мастер-рулон',
      pfrDescr: 'Профилеразмер',
      kolShtPart: 'Количество труб в связке',
      sposobUkladUpakovka: 'Способ отгрузки',
      ordheadText: 'Примечание менеджера SAP',
      okpoConsignee: 'ОКПО грузополучателя',
      tnglConsignee: 'ТНГЛ грузополучателя',
      innConsignee: 'ИНН грузополучателя',
      contractNoLog: 'Договор для СМГС',
      eskBuyer: 'ЕСК покупателя',
      eskConsignee: 'ЕСК грузополучателя',
      lprio: 'Приоритет поставки',
      shipperName: 'ФИО отгрузившего',
      buyer: 'Наименование покупателя',

      invoice: 'Номер накладной перв.плеча',
      wadat_ist: 'Дата накладной перв.плеча',
      marka: 'Марка стали',
      stornoFlag: 'Изменение СК',
      note: 'Комментарий',
      batchId: '№ партии SAP',
      endCustomerName: 'Конечный потребитель',

      nextPlant: 'Следующий экспедитор',
      freightOrder: '№ ФЗ поступления на склад',
      decision: 'Решение',
      onHoldFlag: 'Карантин',
      materialSize: 'Профили размера',

      hasShippingPlan: 'Запланировано к отгрузке',
      shippingPlanContainerType: 'Тип контейнера',
      shippingPlanDate: 'Плановая дата погрузки экспедитора',
      shippingPlanUserName: 'ФИО планировщика',
      shippingPlanContainerNumber: '№ планируемого контейнера',
      transpOrder: '№ ФЗ отгрузки со склада',
      departureDate: 'Дата убытия баржи',
      conservationQmet: 'Тип консервации',
      grPoverh: 'Группа поверхности',
      nomProekta: 'Номер проекта',
      remainingTimeProduction: 'Осталось времени (производство)',
      inco1: 'Инкотермс',
      prohibition: 'Запрет на отгрузку',
      internalPieceId: 'Внутренний номер',
      vidProd: 'Тип продукта',
      storageTimeCount: 'Срок хранения',
      remainingTimeCount: 'Осталось времени',
      overStorageTimeCount: 'Сверх.норм.хранение',
      overStorageDates: 'Дата Св.Н отчета',
      shippingOnBoards: 'Способ погрузки в вагон',
      nameOfMaterial: 'Материал',
      kdMat: 'Номенклатура',
      kromka: 'Кромка',
      containerInspectedFlag: 'Осмотр контейнера',
      registerFlag: 'Регистр',
      ttnDocStatusDescr: 'Статус ТН',
      ttnNumId: 'ID ТН',
      internalLt: 'Внутренний LT',
      pfCertNo: 'Номер СК ПФ',
      semiCgId: 'Номер партии ПФ',
      semiActualPieceId: 'Номер УЕ ПФ',
      productPlanDistr: '№ SKU ПФ',
      pieceId: 'Маркировка',
      clientArrivalDate: 'Дата факт. прибытия',
      clientDeliveryTime: 'Срок доставки',
      accountingDocNumber: '№ бух. документа',
      accountingDocDate: 'Дата бух. документа',

      M15M4: {
        m15: 'М-4',
        m15NumId: 'id М-4',
        m15DocStatus: 'id М-4 Doc Status',
        m15Date: 'Дата М-4',
        m15DocStatusDescr: 'Статус акта М-4'
      },

      M15BM4: {
        m15b: 'М-4B',
        m15bDate: 'Дата М-4B',
        m15bDocStatus: 'id М-4B Doc Status',
        m15bDocStatusDescr: 'Статус акта М-4B',
        m15bNumId: 'id М-4B'
      },

      MX1M4: {
        documentId: 'М-4',
        mh1NumId: 'id М-4',
        mh1DocStatus: 'id статуса акта М-4',
        mh1Date: 'Дата М-4',
        mh1DocStatusDescr: 'Статус акта М-4',
        departureDate: 'Дата убытия баржи',
        conservationQmet: 'Тип консервации',
        costPerTon: 'Стоимость за тонну',
        grPoverh: 'Группа поверхности',
        nomProekta: 'Номер проекта',
        cost: 'Стоимость'
      },

      consignment: {
        actualPieceId: '№ УЕ',
        cgId: '№ партии',
        customerName: 'Грузополучатель рус.',
        customerNameEng: 'Грузополучатель анг.',
        heatId: '№ плавки',
        knotPurposeSo: 'Целевой узел',
        l4SoId: '№ СЗ сист.',
        length: 'Длина, мм',
        pieceNumId: 'Ключ УЕ',
        productGroupDescription: 'Продукт',
        psStatusName: 'Статус УЕ',
        psStatusNumId: 'ID статуса УЕ',
        qcDate: 'Дата СК',
        qcId: '№ СК',
        qcShopCode: 'Код цеха отгрузки',
        quantity: 'Количество',
        quantityRemain: 'Остаток',
        sapId: '№ УЭ SAP',
        shipmentModeRequirement: 'Способ отгрузки',
        shippingPointNumId: 'Пункт отправки',
        shiptoAddressEnSo: 'Адрес получателя англ.',
        shiptoAddressSo: 'Адрес получателя рус.',
        shiptoRailwayNameSo: 'ЖД назначения',
        shiptoStationCodeSo: 'Код станции назначения',
        shiptoStationNameSo: 'Ст.назначения',
        soDescrId: '№ Заказа',
        soLineDescrId: 'Позиция заказа',
        thick: 'Толщина, мм',
        unitShort: 'Единица измерения',
        vehicleId: '№ тс',
        weightBrutto: 'Вес брутто, т',
        weightNetto: 'Вес нетто, т',
        weightRemain: 'Остаточный вес',
        width: 'Ширина, мм',
        widthFact: 'Фактическая ширина',
        zzordOtsortConf: 'Признак ОХ из заказа',
        planDatePps: 'Плановая дата отгрузки с комбината',
        serialId: 'Данные штрих кода для УЭ',
        rejectedFlag: 'Флаг отказа от приемки',
        incomingDate: 'Дата приемки на склад',
        incomingTime: 'Время приемки на склад',
        incomingStatus: 'Статус принятия УЕ',
        returnFlag: 'Флаг возврата',
        returnVehicle: 'ТС возврата',
        returnReason: 'Причина возврата',
        returnDate: 'Дата возврата',
        plannerNote: 'Примечание',
        documentId: 'МХ-1',
        mh1Date: 'Дата МХ-1',
        mh1NumId: 'id МХ-1',
        mh1DocStatus: 'id МХ-1 Doc Status',
        storageTimeCount: 'Срок хранения',
        remainingTimeCount: 'Осталось времени',
        mh3: 'МХ-3',
        mh3NumId: 'id МХ-3',
        mh3DocStatus: 'id МХ-3 Doc Status',
        mh3Date: 'Дата МХ-3',
        mh3Status: 'Выкуп МХ-3',
        mh3DocStatusDescr: 'Статус акта МХ-3',
        mh1DocStatusDescr: 'Статус акта МХ-1',
        internalPieceId: 'Внутренний номер УЕ',
        klPok: 'Класс цинкового покрытия',
        cvet: 'Цвет покрытия',
        dateOm: 'Дата отгрузки Северсталь',
        accountingDate: 'Дата СК',
        vehicleIdIn: '№ ТС первого плеча',
        shippingPoint: 'Пункт отправки',
        container: '№ контейнера',
        dateLoadInContainer: 'Дата загрузки контейнера',
        plomba: '№ пломбы',
        ttn: '№ ЖД накладной',
        ttnDate: 'Дата накладной',
        vehicleIdOut: '№ ТС отгруженного с УС',
        shippingDate: 'Дата отгрузки с УС',
        shippingTime: 'Время отгрузки с УС',
        incomingUser: 'ФИО принявшего',
        stockDescr: 'Склад',
        areaDescr: 'Зона',
        boxDescr: 'Бокс',
        qcShopDescr: 'Цех-отправитель',
        actualShippingDate: 'Дата фактической отгрузки',
        freightOrder: '№ ФЗ (фрахтовый заказ)',
        actualStorageTimeCount: 'Фактический срок хранения',
        endCustomerName: 'Конечный потребитель',

        deliveryId: 'Номер поставки',
        productType: 'Вид продукта (МС для Мастер-рулона)',
        mcNumId: 'Id Мастер-рулона',
        mcNum: 'Мастер-рулон',
        pfrDescr: 'Профилеразмер',
        kolShtPart: 'Количество труб в связке',
        sposobUkladUpakovka: 'Способ отгрузки',
        ordheadText: 'Примечание менеджера SAP',
        okpoConsignee: 'ОКПО Грузополучателя',
        tnglConsignee: 'ТНГЛ Грузополучателя',
        contractNoLog: 'Договор и наименование покупателя (для СМГС)',
        eskBuyer: 'ЕСК покупателя',
        eskConsignee: 'ЕСК грузополучателя',
        lprio: 'Приоритет поставки',
        shipperName: 'ФИО отгрузившего',

        invoice: 'Номер накладной перв.плеча',
        wadat_ist: 'Дата накладной перв.плеча',
        marka: 'Марка стали',
        stornoFlag: 'Изменение СК',
        note: 'Комментарий',
        batchId: '№ партии SAP',
        nextPlant: 'Следующий экспедитор',

        /* Поля для склада переработки */
        m15: 'М-15',
        m15NumId: 'id М-15',
        m15DocStatus: 'id статуса М-15',
        m15Date: 'Дата М-15',
        m15DocStatusDescr: 'Статус акта М-15',

        m15b: 'М-15B',
        m15bDate: 'Дата М-15B',
        m15bDocStatus: 'id М-15 Doc Status',
        m15bDocStatusDescr: 'Статус акта М-15B',
        m15bNumId: 'id М-15B',

        /* Поля для складов Грайф */
        dateProcessingStart: 'Дата производства',
        commonNumber: 'Общий номер',
        sizes: 'Размеры',

        /* Поле для склада МК-М Самара */
        commonNumberMKM: 'Общий номер',

        decision: 'Решение',
        onHoldFlag: 'Карантин',
        materialSize: 'Профили размера',

        departureDate: 'Дата убытия баржи',
        conservationQmet: 'Тип консервации',
        grPoverh: 'Группа поверхности',
        nomProekta: 'Номер проекта',
        cost: 'Стоимость',
        vidProd: 'Тип продукта',
        overStorageTimeCount: 'Сверх.норм.хранение',
        overStorageDates: 'Дата Св.Н отчета',
        buyoutDate: 'Дата выкупа',
        costPerTon: 'Стоимость за тонну',
        kdMat: 'Номенклатура',

        /* Поля для склада ХАБ */
        statusOfStock: 'Статус запаса'
      },

      azh: {
        mh3: 'Акт завершения хранения',
        mh3NumId: 'id акта завершения хранения',
        mh3DocStatus: 'id акта завершения хранения Doc Status',
        mh3Date: 'Дата акта завершения хранения',
        mh3Status: 'Выкуп акта завершения хранения',
        azhStatusDescr: 'Статус акта завершения хранения'
      },

      recycling: {
        productPlanDistr: '№ SKU ПФ',
        zdvlOrderNumId: 'Заказ ZDVL',
        zdvlLineId: 'Позиция ZDVL',
        taskNumber: 'Номер задания',
        taskDate: 'Дата задания',
        dateProcessingStart: 'Дата передачи в переработку'
      }
    },
    textInfoTab: {
      coordinates: 'Координаты',
      notCoordinates: 'Координат нет',
      detailsPiece: 'Детализация УЕ',
      historyPiece: 'История УЕ',
      coordinatesTS: 'Местоположение ТС',
      pieceInformation: 'Информация по УЕ',
      consignee: 'Грузополучатель',
      orderData: 'Данные по заказу',
      details: 'Детализация'
    },
    textTableHistory: {
      accountingDate: 'Дата',
      modDatetime: 'Дата и время',
      actionNumId: 'Id',
      actionType: 'Тип',
      userFullName: 'ФИО пользователя',
      userName: 'Логин пользователя',
      attrbCode: 'Наименование',
      attrbNumId: 'Id',
      attrbValue: 'Значение',
      attrbValueOld: 'Прежнее значение'
    },
    textTableProduction: {
      profileSize: 'Профилеразмер',
      dateCK: 'Дата СК(ГП)',
      consignmentSAP: 'Партия SAP',
      numberConsignment: 'Номер партии ГП(№СК)',
      numberPiece: 'Номер УЕ',
      statusPiece: 'Статус УЕ',
      weightConsignment: 'Вес партии ГП',
      orderZDVL: 'Заказ ZDVL',
      positionZdvl: 'Позиция ZDVL',
      height: 'Длина',
      thickness: 'Толщина',
      steelGrade: 'Марка стали',
      normativeDocument: 'Номативный документ',
      amount: 'Количество',
      CK: 'CK(ПФ)',
      readyWeightNetto: 'Кол-во ГП, теор.',
      readyWeightOff: 'Кол-во ГП, факт.',
      weight: 'Вес',
      weightRest: 'Вес ост',
      weightCut: 'Вес обрези',
      weightDO: 'Вес ДО',
      weightWriteOf: 'Вес списания',
      wastePercent: '% отходов'
    },
    textTableRecyclingOrders: {
      actualPieceId: 'Номер УЕ',
      accountingDate: 'Дата СК (рулон)',
      batchId: 'Партия SAP',
      capacityAccepted: 'Подтверждено (передано в SAP)',
      capacityAvailable: 'Доступно к производству',
      capacityPipe: 'Объем ГП',
      semiWidth: 'Ширина',
      semiThickness: 'Толщина',
      capacityPipeMeasure: 'Объем ГП, ЕИ',
      capacityTied: 'Объем привязанного',
      capacityPipeMeasureShort: 'Единица измерения ГП',
      capacityEndProduct: 'Введенный объем ГП',
      cgId: 'Номер партии',
      clientName: 'Клиент',
      contractDate: 'Дата контракта',
      contractId: 'Номер контракта',
      customerName: 'Наименование заказчика',
      executorName: 'Наименование исполнителя',
      expireDate: 'Дата окончания заказа на переработку',
      incomingDate: 'Дата приёмки (по М-4)',
      lengthCoil: 'Размер ПФ, длина',
      lengthPipe: 'Длина ГП мм',
      lineId: 'Номер позиции в SAP ERP',
      lineStatus: 'Код статуса позиции заказа',
      lineStatusTitle: 'Статус позиции заказа',
      markCoil: 'Марка стали ПФ',
      markPipe: 'Марка стали ГП',
      matnrComponentsText: 'Материал ПФ',
      matnrGpText: 'Материал ГП',
      matnrGp: 'Код материала ГП',
      orderDate: 'Дата заказа на переработку',
      orderId: 'Номер заказа на переработку',
      orderStatus: 'Код статуса заказа на переработку',
      orderStatusTitle: 'Статус заказа на переработку',
      price: 'Цена услуги по переработке, р/тн с НДС',
      productGroupDescription: 'Продукт',
      project: 'Номер проекта',
      psStatusName: 'Статус УЕ',
      qcId: 'СК (рулон)',
      quantity: 'Кол-во',
      quantityRemain: 'Кол-во, ост.',
      rolls: 'Рулоны',
      sizeCoilMeasure: 'Размер ПФ, ЕИ',
      sizePipe: 'Профилеразмер ГП',
      sizePipeMeasure: 'Длина ГП, ЕИ',
      skuCoil: 'SKU ПФ',
      skuCoilId: 'id SKU ПФ',
      thicknessPipe: 'Толщина ГП мм',
      widthPipe: 'Ширина ГП мм',

      skuPipe: 'SKU ГП',
      skuPipeId: 'id SKU ГП',
      standardCoil: 'Стандарт на ПФ',
      standardPipe: 'Стандарт на ГП',
      unitShort: 'ЕИ',
      weightNetto: 'Вес, т.',
      weightRemain: 'Вес ост., т.',
      weightTrim: 'Вес обрези, т.',
      weightWaste: 'Вес ДО, т.',
      weightEndProduct: 'Вес ГП, т.',
      weightCoil: 'Вес ПФ тн',
      weightCoilMeasure: 'Вес ПФ, ЕИ',
      widthCoil: 'Размер ПФ, ширина',
      zdvlOrderLineId: 'Номер позиции заказа',
      zdvlOrderNumId: 'id заказа на переработку',
      zdvlLineNumId: 'Позиция ZDVL',
      zdvlLineId: 'Номер позиции заказа на переработку',
      thick: 'Толщина ПФ',
      width: 'Ширина ПФ',
      taskNumber: 'Номер задания',
      taskDate: 'Дата задания',
      additionalStatus: 'Статус этапа',
      kromka: 'Кромка',
      quantityOff: 'Вес нетто (количество)',
      l4SoId: '№ сбытового заказа',
      noticeDatetime: 'Время уведомления',
      plantDescr: 'Склад',
      batchIds: 'Партии SAP ПФ'
    },
    textTableSO: {
      batchId: 'Номер партии',
      conditionOfShipmentName: 'Условие отгрузки',
      consignee: 'Грузополучатель',
      createDate: 'Дата создания',
      customer: 'Заказчик',
      depositor: 'Грузотправитель (Продавец) наименование краткое',
      materialText: 'Материал',
      pieceId: 'Номер УЕ',
      pieceStatusName: 'Статус УЕ',
      qcId: '№ СК ГП',
      reasonForTheBan: 'Причина запрета',
      salesOrderLineCurrentCapacity: 'Количество привязанной ГП (текущее)',
      salesOrderLineMaxCapacity: 'Количество ГП (максимальное)',
      salesOrderLineMinCapacity: 'Количество ГП (минимальное)',
      salesOrderLineName: 'Материал',
      salesOrderLineNominalCapacity: 'Количество ГП (номинальное)',
      salesOrderLineNum: '№ позиции',
      salesOrderLineRemainsCapacity: 'Доступно к привязке (остаток)',
      salesOrderNum: '№ заказа',
      salesOrderSystemNum: '№ заказа системный',
      sapId: 'Партия SAP',
      shiptoRailwayCodeSo: 'Железно-дорожное транспортное агентство',
      shiptoRailwayNameSo: 'Наименование железной дороги',
      shiptoStationCodeSo: 'Станция назначения',
      shiptoStationNameSo: 'Наименование станции назначения',
      soLineNum: '№ позиции сбытового заказа',
      soNum: '№ сбытового заказа',
      sortingType: 'Вид отсортировки',
      specDate: 'Дата спецификации',
      statusName: 'Статус',
      thickness: 'Толщина',
      weight: 'Количество',
      width: 'Ширина',
      zdvlOrderLineNum: '№ позиции заказа на переработку',
      zdvlOrderNum: '№ заказа на переработку'
    },
    textTableAdminMessages: {
      modDateTime: 'Время изменения',
      modUserId: 'ID автора последнего изменения',
      msgDateTime: 'Время сообщения',
      msgCounter: 'ID сообщения',
      msgId: 'Тип',
      status: 'Статус',
      clientId: 'Id клиента',
      msgGuid: 'GUID',
      statusDesc: 'Описание статуса',
      msgDesc: 'Описание типа',
      msgRemark: 'Текст ошибки',
      evnCounter: 'Идентификатор внутренний',
      attemptsCount: 'Кол-во попыток',
      errorText: 'Текст ошибки',
      queueId: 'Id очереди',
      sapGuid: 'GUID',
      msgSapId: 'GUID',
      msgReprocessNr: 'Попытки обработки',
      docId: 'Номер документа'
    },
    textTableAdminMailing: {
      attachments: 'Вложения',
      body: 'Тело сообщения',
      destinationEmail: 'Получатель',
      error: 'Ошибка',
      modDateTime: 'Время отправки',
      modUser: 'ФИО пользователя',
      senderEmail: 'Отправитель',
      status: 'Статус отправки',
      subject: 'Тема'
    },
    textTableAdminActs: {
      creationUser: 'ФИО создателя',
      docDate: 'Дата акта',
      docId: 'Номер акта',
      docNumId: 'ID акта',
      docStatus: 'Статус акта (id)',
      docStatusDesc: 'Статус акта (описание)',
      docType: 'Тип акта (описание)',
      docTypeNumId: 'Тип акта (id)',
      eventId: 'ID сообщения',
      eventStatus: 'Статус сообщения',
      extGuid: 'GUID сторонней системы',
      extSign: 'Подпись внешняя',
      extSignDatetime: 'Дата внешней подписи',
      guid: 'GUID',
      inSign: 'Подпись внутренняя',
      inSignDatetime: 'Дата внутренней подписи',
      modDatetime: 'Время изменения',
      modUser: 'ФИО изменившего',
      stockDescr: 'Склад'
    },
    workingDetailing: {
      deleteCommit: 'Удалить комментарий?',
      notData: 'Нет данных для отображения',
      deleteSelectPhoto: 'Удалить выбранные фото?',
      deleteText: 'Удалить',
      labelEmail: 'Заголовок письма',
      errorSubject: 'Введите заголовок',
      labelEmailTo: 'Email получателя',
      errorEmailTo1: 'Введите email получателя',
      errorEmailTo2: 'Email введен не правильно',
      labelBody: 'Тело письма',
      errorBody: 'Введите тело письма',
      commit: 'Комментарий',
      save: 'Сохранить',
      photo: 'Фото',
      files: 'Файлы',
      allowedTypes: 'Допустимые расширения файла:',
      send: 'Отправить',
      sendToEmail: 'Отправить на email',
      textPhoto: 'Отметьте галочками те фото, которые необходимо отправить',
      decision: 'Аттестация',
      holdOn: 'Карантин',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptDecision: 'Решение принято',
      declineDecision: 'Решение отклонено'
    },
    textTableTasks: {
      mark: 'Марка',
      profileSize: 'Профиль',
      readyProductSum: 'ГП',
      remain: 'Остаток',
      semiProductSum: 'ПФ',
      sku: 'SKU',
      sum: 'Объем задания',
      taskNumId: 'ID задания',
      taskNumber: 'Номер задания',
      taskDate: 'Дата задания',
      matnrGpText: 'Материал ГП',
      statusName: 'Статус',
      plantDescr: 'Склад'
    },
    production: {
      deleteConfirmation: {
        deleteConfirmationP1: 'Вы действительно хотите удалить партию ГП №',
        deleteConfirmationP2: 'в количестве'
      },
      inputTrim: 'Ввод обрези',
      inputWaste: 'Ввод ДО',
      inputReady: 'Ввод ГП',
      inputUndercut: 'Ввод подкроя',
      inputAllWaste: 'Ввод отходов',
      semiTab: 'Ввод факта пр-ва (работа с ПФ)',
      undectutConfirmTab: 'Подтверждение подкроя',
      readyTab: 'Ввод факта пр-ва (работа с ГП)',
      readyConfirmationTab: 'Подтверждение факта пр-ва'
    },
    filters: {
      codeType: 'Тип сообщения',
      codeStatus: 'Статус сообщения',
      dateEnd: 'Дата по',
      dateFrom: 'Дата с',
      numberEnd: 'Номер по',
      numberFrom: 'Номер с',
      docId: 'Номер документа'
    },
    directions: {
      MET_SAP: 'Из MES в SAP',
      C1_MET: 'Из 1C в MES',
      MET_1C: 'Из MES в 1C',
      SAP_MET: 'Из SAP в MES'
    },
    messageTypeFilter: {
      C1_MET: {
        N: 'Не выбрано',
        9003: 'Заявка на акт',
        9008: 'Производство',
        9009: 'Отгрузка'
      },

      SAP_MET: {
        N: 'Не выбрано',
        4307: 'Таблица раскроя',
        4332: 'Подпись акта',
        4334: 'Поступление',
        4338: 'Заказ ZDVL',
        4339: 'Дислокация ТС ТМ',
        4340: 'Дислокация ЖД',
        4341: 'Дислокация ЖД',
        4342: 'Сбытовой заказ',
        6301: 'ФЗ из ТМ',
        6405: 'Многосекционная баржа'
      },

      MET_SAP: {
        N: 'Не выбрано',
        4337: 'Документ для EDI',
        4338: 'ТТН',
        4339: 'Подписание ZDVL',
        4340: 'Статус СК для ТМ',
        4341: 'Перемещение по забалансу',
        4342: 'Производство',
        4343: 'Подкрой'
      },

      MET_1C: {
        N: 'Не выбрано',
        9003: 'Заявка на акт',
        9008: 'Производство',
        9009: 'Отгрузка'
      }
    },
    support: {
      notData: 'Нет данных для отображения',
      photo: 'Фото',
      add: 'Прикрепить',
      message: 'Обращение в службу поддержки',
      errorMessage: 'Обращение не должно быть пустым',
      send: 'Отправить'
    },
    administrationTabs: {
      signPopup: {
        enterName: 'Введите ФИО',
        enterDate: 'Введите дату'
      },
      buttons: {
        sign: 'Подписать',
        cancelSign: 'Отменить подпись',
        resend: 'Отправить повторно',
        changeStatus: 'Изменить статус',
        changePlant: 'Изменить склад'
      },
      tabs: {
        userAdmin: 'Пользователи',
        userRole: 'Роли',
        pieces: 'Работа с УЕ',
        messages: 'Интеграция',
        mailing: 'Рассылки',
        acts: 'Акты',
        contracts: 'Договоры'
      }
    },
    searchBar: {
      placeholder: 'Введите ключевое слово...',
      filter: 'Фильтр',
      searchButton: 'Поиск',
      filterSettings: 'Настройки фильтрации',
      placeholderPlant: 'Введите название склада....'
    },
    task: {
      textSemiHeading: 'Полуфабрикаты'
    },
    undercutTab: {
      deleteUndercutConfirm: 'Вы действительно хотите удалить подкрой?',
      selectedUndercut: 'Выбранный рулон',
      typeUndercut: 'Тип подкроя',
      selectUndercutType: 'Выберите вариант подкроя',
      cuttings: 'Подкройные полосы'
    },
    wasteBalalancingTotalAverage: 'Итог. среднее',
    textVisit: {
      userName: 'Логин',
      fullName: 'ФИО',
      plantShortDescr: 'Склад',
      sessionStart: 'Время начала',
      sessionEnd: 'Время конца'
    },
    adminPanel: {
      textDeleteContract: 'Вы действительно хотите удалить договор',
      textDeleteContractTitle: 'Удаление договора',
      textAddContractTitle: 'Добавить договор',
      textUpdateContractTitle: 'Обновление договора',
      contractId: 'ID договора',
      contractNumberSys: 'Номер договора (системный)',
      contractNumberLog: 'Номер договора (логический)',
      contractDate: 'Дата договора'
    },
    stockConfigure: {
      plant: 'Склад',
      area: 'Зона',
      box: 'Бокс',
      collapseAll: 'Свернуть полностью',
      expandAll: 'Развернуть полностью',
      addArea: 'Добавить зону',
      addBox: 'Добавить бокс',
      deleteLevel: 'Удалить уровень',
      editLevel: 'Редактировать уровень',
      noParentDesc: 'Без родителя',
      description: 'Название',
      configCode: 'Конф. завода',
      parentLevel: 'Родительский уровень',
      holderId: 'Q-дебитор',
      sapCode: 'Код склада SAP',
      deleteConfirm: 'Вы действительно хотите удалить уровень'
    },
    textTN: {
      additionalData: 'Дополнительные данные',
      dateTN: 'Дата ТН',
      docNum: '№ документа',
      docType: 'Вид документа',
      driverData: 'Данные водителя',
      driverMiddleName: 'Отчество',
      driverName: 'Имя',
      driverLastName: 'Фамилия',
      note: 'Примечание',
      numberTN: 'Номер ТН',
      packingType: 'Тип упаковки',
      selectTN: 'Выбрать ТН',
      select: 'Выбрать',
      vehicleData: 'Данные транспортного средства',
      vehicleNum: 'Рег.№(Авто)',
      vehicleModel: 'Марка авто',
      vehicleType: 'Тип ТС',
      driverDocumentNumber: '№ документа',
      familyName: 'Фамилия',
      givenName: 'Имя',
      middleName: 'Отчество',
      driverDocumentType: 'Вид документа',
      passport: 'Паспорт',
      driverLicense: 'Водительское удостоверение',
      selectDocumentType: 'Сначала выберите тип документа',
      selectVehicleType: 'Сначала выберите тип ТС',
      auto: 'Авто',
      trailer: 'Прицеп',
      isExpeditor: 'Является экспедитором',
      trailerNum: 'Рег.№(Прицеп)',
      separationWeight: 'Вес сепарации, кг',
      supportingDocuments: 'Сопроводительные документы',
      supportingDocumentsValue: 'ТН, акты, сертификаты',
      supportingDocumentsEmpty: 'Пусто',
      responsiblePersonData: 'Данные уполномоченного лица со стороны отправителя',
      responsiblePersonFullName: 'ФИО',
      responsiblePersonPost: 'Должность',
      transportCompanyData: 'Транспортная компания',
      transportCompanyName: 'Наименование',
      inn: 'ИНН',
      address: 'Адрес'
    },
    textTnColumn: {
      accountingDate: 'Дата СК',
      actualPieceId: '№ УЕ',
      actualShippingDate: 'Актуальная дата отгрузки',
      address: 'Адрес',
      cgId: '№ партии',
      docStatus: 'Статус ТН',
      docStatusDescr: 'Статус ТН',
      documentNumber: '№ документа',
      documentType: 'Тип документа',
      driverNameShort: 'ФИО водителя',
      expeditorFlag: 'Экспедитор',
      familyName: 'Фамилия',
      fullName: 'ФИО',
      givenName: 'Имя',
      grossWeight: 'Вес брутто, т',
      inn: 'ИНН',
      middleName: 'Отчество',
      netWeight: 'Вес нетто, т',
      packingType: 'Название',
      position: 'Должность',
      psStatusName: 'Статус УЕ',
      qcId: '№ СК',
      transportCompanyName: 'Наименование',
      ttnDocumentDate: 'Дата ТН',
      ttnDocumentId: '№ ТН',
      ttnDocumentNumId: 'id ТН',
      vehicleBrand: 'Марка ТС',
      vehicleId: '№ ТС',
      vehicleNum: '№ ТС',
      vehicleType: 'Тип ТС',
      weight: 'Вес',
      weightSeparation: 'Вес сепарации, кг'
    },
    tnStatus: {
      created: 'Создан',
      show: 'Сформирован',
      confirm: 'Подтвержден'
    },
    textConsent: {
      title: 'Согласие на обработку персональных данных',
      accept: 'Принимаю условия соглашения',

      p1: `На основании Федерального закона Российской Федерации от 27 июля 2006 г. № 152-ФЗ
    «О персональных данных» настоящим выражаю свое согласие на обработку ПАО «Северсталь»
    расположенному по адресу: 162608, Вологодская обл., г. Череповец, ул. Мира, д. 30,
    (далее - Оператор) моих персональных данных, включая: фамилию, имя, отчество,  адрес
    электронной почты, номер телефона с целью предоставления доступа к ИС «MES Удаленный склад»`,

      p2: `Предоставляю Оператору право осуществлять автоматизированную, а также без использования 
    средств автоматизации обработку моих персональных данных, совершать в документарной и 
    электронной форме все действия (операции) с моими персональными данными, включая сбор, 
    запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), 
    извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, 
    удаление, уничтожение персональных данных.`,

      p3: `Настоящим я подтверждаю, что согласен на поручение обработки персональных данных 
    АО «Северсталь-инфоком» (г. Череповец, ул. Ленина, д. 123А) с целью обслуживания информационных систем.`,

      p4: 'Настоящее согласие действует в течении 3 лет.',

      p5: `Условием прекращения обработки Оператором персональных данных является окончание срока, 
    указанного в настоящем согласии, или получение Оператором письменного отзыва настоящего согласия 
    (отзыв настоящего согласия производится посредством составления соответствующего письменного документа, 
    который может быть направлен мной в адрес Оператора по почте заказным письмом с уведомлением о вручении 
    либо вручен лично под расписку представителю Оператора). Оператор   прекращает обработку персональных 
    данных и уничтожает их в срок, не превышающий 30 дней с даты поступления указанного отзыва, если иное 
    не предусмотрено федеральным законодательством`,

      p6: 'Ссылка на «Политику в области обработки и защиты персональных данных»'
    }
  }
};
